// source: protocol/manage.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global =
    (typeof globalThis !== 'undefined' && globalThis) ||
    (typeof window !== 'undefined' && window) ||
    (typeof global !== 'undefined' && global) ||
    (typeof self !== 'undefined' && self) ||
    (function () { return this; }).call(null) ||
    Function('return this')();

var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
var google_protobuf_timestamp_pb = require('google-protobuf/google/protobuf/timestamp_pb.js');
goog.object.extend(proto, google_protobuf_timestamp_pb);
var protocol_customer_pb = require('../protocol/customer_pb.js');
goog.object.extend(proto, protocol_customer_pb);
var protocol_plan_pb = require('../protocol/plan_pb.js');
goog.object.extend(proto, protocol_plan_pb);
var protocol_histogram_pb = require('../protocol/histogram_pb.js');
goog.object.extend(proto, protocol_histogram_pb);
goog.exportSymbol('proto.saasphoto.AddSystemNotifyRequest', null, global);
goog.exportSymbol('proto.saasphoto.AddUseCreditModuleRequest', null, global);
goog.exportSymbol('proto.saasphoto.AddUserPlanRequest', null, global);
goog.exportSymbol('proto.saasphoto.AnalyticsBreakdown', null, global);
goog.exportSymbol('proto.saasphoto.AnalyticsRiskAccount', null, global);
goog.exportSymbol('proto.saasphoto.AnalyticsTrendPoint', null, global);
goog.exportSymbol('proto.saasphoto.BandwidthUsage', null, global);
goog.exportSymbol('proto.saasphoto.ChangeAccountTypeRequest', null, global);
goog.exportSymbol('proto.saasphoto.ChangeUserEmailRequest', null, global);
goog.exportSymbol('proto.saasphoto.ChangeUserPasswordRequest', null, global);
goog.exportSymbol('proto.saasphoto.CreateAccountErrorCode', null, global);
goog.exportSymbol('proto.saasphoto.CreateAccountRequest', null, global);
goog.exportSymbol('proto.saasphoto.CreateAccountResponse', null, global);
goog.exportSymbol('proto.saasphoto.CreditUsageSource', null, global);
goog.exportSymbol('proto.saasphoto.CreditUserUsage', null, global);
goog.exportSymbol('proto.saasphoto.DeleteSystemNotifyRequest', null, global);
goog.exportSymbol('proto.saasphoto.GenerateUserPasswordRequest', null, global);
goog.exportSymbol('proto.saasphoto.GetAccountTypesResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetAgentsResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetBandwidthUsagesRequest', null, global);
goog.exportSymbol('proto.saasphoto.GetBandwidthUsagesResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetBusinessInsightsRequest', null, global);
goog.exportSymbol('proto.saasphoto.GetBusinessInsightsResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetCreditStatisticsRequest', null, global);
goog.exportSymbol('proto.saasphoto.GetCreditStatisticsResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetGroup', null, global);
goog.exportSymbol('proto.saasphoto.GetGroupsList', null, global);
goog.exportSymbol('proto.saasphoto.GetPaymentStatisticsRequest', null, global);
goog.exportSymbol('proto.saasphoto.GetPaymentStatisticsResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetPoliciesList', null, global);
goog.exportSymbol('proto.saasphoto.GetPolicy', null, global);
goog.exportSymbol('proto.saasphoto.GetStorageUsagesResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetSubscriptionStatusResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetSystemNotifiesResponse', null, global);
goog.exportSymbol('proto.saasphoto.GetUserBandwidthUsagesRequest', null, global);
goog.exportSymbol('proto.saasphoto.GetUserBandwidthUsagesResponse', null, global);
goog.exportSymbol('proto.saasphoto.Group', null, global);
goog.exportSymbol('proto.saasphoto.GroupsList', null, global);
goog.exportSymbol('proto.saasphoto.IsUserEmailExistRequest', null, global);
goog.exportSymbol('proto.saasphoto.IsUserEmailExistResponse', null, global);
goog.exportSymbol('proto.saasphoto.LatestPlan', null, global);
goog.exportSymbol('proto.saasphoto.OrteryDirect', null, global);
goog.exportSymbol('proto.saasphoto.PoliciesList', null, global);
goog.exportSymbol('proto.saasphoto.Policy', null, global);
goog.exportSymbol('proto.saasphoto.RevenuePayment', null, global);
goog.exportSymbol('proto.saasphoto.SalesReport', null, global);
goog.exportSymbol('proto.saasphoto.SalesReportRequest', null, global);
goog.exportSymbol('proto.saasphoto.SalesReportResponse', null, global);
goog.exportSymbol('proto.saasphoto.SearchRequest', null, global);
goog.exportSymbol('proto.saasphoto.SearchResponse', null, global);
goog.exportSymbol('proto.saasphoto.SendSystemNotifyMailRequest', null, global);
goog.exportSymbol('proto.saasphoto.StorageUsage', null, global);
goog.exportSymbol('proto.saasphoto.SystemNotifyDetail', null, global);
goog.exportSymbol('proto.saasphoto.Transaction', null, global);
goog.exportSymbol('proto.saasphoto.TransactionName', null, global);
goog.exportSymbol('proto.saasphoto.UpdateSystemNotifiesRequest', null, global);
goog.exportSymbol('proto.saasphoto.UpdateUserStatusRequest', null, global);
goog.exportSymbol('proto.saasphoto.UsageDetail', null, global);
goog.exportSymbol('proto.saasphoto.User', null, global);
goog.exportSymbol('proto.saasphoto.UserStatus', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.Policy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.Policy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.Policy.displayName = 'proto.saasphoto.Policy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.Group = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.Group, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.Group.displayName = 'proto.saasphoto.Group';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.PoliciesList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.PoliciesList.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.PoliciesList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.PoliciesList.displayName = 'proto.saasphoto.PoliciesList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GroupsList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GroupsList.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GroupsList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GroupsList.displayName = 'proto.saasphoto.GroupsList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetPolicy = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetPolicy, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetPolicy.displayName = 'proto.saasphoto.GetPolicy';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetGroup = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetGroup, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetGroup.displayName = 'proto.saasphoto.GetGroup';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetPoliciesList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetPoliciesList.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetPoliciesList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetPoliciesList.displayName = 'proto.saasphoto.GetPoliciesList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetGroupsList = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetGroupsList.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetGroupsList, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetGroupsList.displayName = 'proto.saasphoto.GetGroupsList';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.AddSystemNotifyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.AddSystemNotifyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.AddSystemNotifyRequest.displayName = 'proto.saasphoto.AddSystemNotifyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.SystemNotifyDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.SystemNotifyDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.SystemNotifyDetail.displayName = 'proto.saasphoto.SystemNotifyDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetSystemNotifiesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetSystemNotifiesResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetSystemNotifiesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetSystemNotifiesResponse.displayName = 'proto.saasphoto.GetSystemNotifiesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.DeleteSystemNotifyRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.DeleteSystemNotifyRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.DeleteSystemNotifyRequest.displayName = 'proto.saasphoto.DeleteSystemNotifyRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.UpdateSystemNotifiesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.UpdateSystemNotifiesRequest.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.UpdateSystemNotifiesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.UpdateSystemNotifiesRequest.displayName = 'proto.saasphoto.UpdateSystemNotifiesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.CreateAccountRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.CreateAccountRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.CreateAccountRequest.displayName = 'proto.saasphoto.CreateAccountRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.CreateAccountResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.CreateAccountResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.CreateAccountResponse.displayName = 'proto.saasphoto.CreateAccountResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.SalesReportRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.SalesReportRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.SalesReportRequest.displayName = 'proto.saasphoto.SalesReportRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.SalesReportResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.SalesReportResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.SalesReportResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.SalesReportResponse.displayName = 'proto.saasphoto.SalesReportResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.SalesReport = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.SalesReport, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.SalesReport.displayName = 'proto.saasphoto.SalesReport';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetAgentsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetAgentsResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetAgentsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetAgentsResponse.displayName = 'proto.saasphoto.GetAgentsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetAccountTypesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetAccountTypesResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetAccountTypesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetAccountTypesResponse.displayName = 'proto.saasphoto.GetAccountTypesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.SearchRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.SearchRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.SearchRequest.displayName = 'proto.saasphoto.SearchRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.SearchResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.SearchResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.SearchResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.SearchResponse.displayName = 'proto.saasphoto.SearchResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.User = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.User.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.User, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.User.displayName = 'proto.saasphoto.User';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.OrteryDirect = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.OrteryDirect, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.OrteryDirect.displayName = 'proto.saasphoto.OrteryDirect';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.LatestPlan = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.LatestPlan, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.LatestPlan.displayName = 'proto.saasphoto.LatestPlan';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.Transaction = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.Transaction, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.Transaction.displayName = 'proto.saasphoto.Transaction';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.UsageDetail = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.UsageDetail, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.UsageDetail.displayName = 'proto.saasphoto.UsageDetail';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.ChangeAccountTypeRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.ChangeAccountTypeRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.ChangeAccountTypeRequest.displayName = 'proto.saasphoto.ChangeAccountTypeRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.ChangeUserEmailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.ChangeUserEmailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.ChangeUserEmailRequest.displayName = 'proto.saasphoto.ChangeUserEmailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.ChangeUserPasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.ChangeUserPasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.ChangeUserPasswordRequest.displayName = 'proto.saasphoto.ChangeUserPasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GenerateUserPasswordRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GenerateUserPasswordRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GenerateUserPasswordRequest.displayName = 'proto.saasphoto.GenerateUserPasswordRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.UpdateUserStatusRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.UpdateUserStatusRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.UpdateUserStatusRequest.displayName = 'proto.saasphoto.UpdateUserStatusRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.AddUserPlanRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.AddUserPlanRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.AddUserPlanRequest.displayName = 'proto.saasphoto.AddUserPlanRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.SendSystemNotifyMailRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.SendSystemNotifyMailRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.SendSystemNotifyMailRequest.displayName = 'proto.saasphoto.SendSystemNotifyMailRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetBandwidthUsagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetBandwidthUsagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetBandwidthUsagesRequest.displayName = 'proto.saasphoto.GetBandwidthUsagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetBandwidthUsagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetBandwidthUsagesResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetBandwidthUsagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetBandwidthUsagesResponse.displayName = 'proto.saasphoto.GetBandwidthUsagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.StorageUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.StorageUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.StorageUsage.displayName = 'proto.saasphoto.StorageUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetStorageUsagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetStorageUsagesResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetStorageUsagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetStorageUsagesResponse.displayName = 'proto.saasphoto.GetStorageUsagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetUserBandwidthUsagesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetUserBandwidthUsagesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetUserBandwidthUsagesRequest.displayName = 'proto.saasphoto.GetUserBandwidthUsagesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.BandwidthUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.BandwidthUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.BandwidthUsage.displayName = 'proto.saasphoto.BandwidthUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetUserBandwidthUsagesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetUserBandwidthUsagesResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetUserBandwidthUsagesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetUserBandwidthUsagesResponse.displayName = 'proto.saasphoto.GetUserBandwidthUsagesResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetSubscriptionStatusResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetSubscriptionStatusResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetSubscriptionStatusResponse.displayName = 'proto.saasphoto.GetSubscriptionStatusResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetPaymentStatisticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetPaymentStatisticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetPaymentStatisticsRequest.displayName = 'proto.saasphoto.GetPaymentStatisticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.RevenuePayment = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.RevenuePayment, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.RevenuePayment.displayName = 'proto.saasphoto.RevenuePayment';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetPaymentStatisticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetPaymentStatisticsResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetPaymentStatisticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetPaymentStatisticsResponse.displayName = 'proto.saasphoto.GetPaymentStatisticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetCreditStatisticsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetCreditStatisticsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetCreditStatisticsRequest.displayName = 'proto.saasphoto.GetCreditStatisticsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.CreditUsageSource = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.CreditUsageSource, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.CreditUsageSource.displayName = 'proto.saasphoto.CreditUsageSource';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.CreditUserUsage = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.CreditUserUsage.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.CreditUserUsage, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.CreditUserUsage.displayName = 'proto.saasphoto.CreditUserUsage';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetCreditStatisticsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetCreditStatisticsResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetCreditStatisticsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetCreditStatisticsResponse.displayName = 'proto.saasphoto.GetCreditStatisticsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.AnalyticsBreakdown = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.AnalyticsBreakdown, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.AnalyticsBreakdown.displayName = 'proto.saasphoto.AnalyticsBreakdown';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.AnalyticsTrendPoint = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.AnalyticsTrendPoint, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.AnalyticsTrendPoint.displayName = 'proto.saasphoto.AnalyticsTrendPoint';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.AnalyticsRiskAccount = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.AnalyticsRiskAccount, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.AnalyticsRiskAccount.displayName = 'proto.saasphoto.AnalyticsRiskAccount';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetBusinessInsightsRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.GetBusinessInsightsRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetBusinessInsightsRequest.displayName = 'proto.saasphoto.GetBusinessInsightsRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.GetBusinessInsightsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.saasphoto.GetBusinessInsightsResponse.repeatedFields_, null);
};
goog.inherits(proto.saasphoto.GetBusinessInsightsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.GetBusinessInsightsResponse.displayName = 'proto.saasphoto.GetBusinessInsightsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.AddUseCreditModuleRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.AddUseCreditModuleRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.AddUseCreditModuleRequest.displayName = 'proto.saasphoto.AddUseCreditModuleRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.IsUserEmailExistRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.IsUserEmailExistRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.IsUserEmailExistRequest.displayName = 'proto.saasphoto.IsUserEmailExistRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.saasphoto.IsUserEmailExistResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.saasphoto.IsUserEmailExistResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.saasphoto.IsUserEmailExistResponse.displayName = 'proto.saasphoto.IsUserEmailExistResponse';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.Policy.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.Policy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.Policy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.Policy.toObject = function(includeInstance, msg) {
  var f, obj = {
    sub: jspb.Message.getFieldWithDefault(msg, 1, ""),
    obj: jspb.Message.getFieldWithDefault(msg, 2, ""),
    act: jspb.Message.getFieldWithDefault(msg, 3, ""),
    eft: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.Policy}
 */
proto.saasphoto.Policy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.Policy;
  return proto.saasphoto.Policy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.Policy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.Policy}
 */
proto.saasphoto.Policy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSub(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObj(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAct(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEft(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.Policy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.Policy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.Policy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.Policy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSub();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObj();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAct();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEft();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string sub = 1;
 * @return {string}
 */
proto.saasphoto.Policy.prototype.getSub = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Policy} returns this
 */
proto.saasphoto.Policy.prototype.setSub = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string obj = 2;
 * @return {string}
 */
proto.saasphoto.Policy.prototype.getObj = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Policy} returns this
 */
proto.saasphoto.Policy.prototype.setObj = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string act = 3;
 * @return {string}
 */
proto.saasphoto.Policy.prototype.getAct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Policy} returns this
 */
proto.saasphoto.Policy.prototype.setAct = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string eft = 4;
 * @return {string}
 */
proto.saasphoto.Policy.prototype.getEft = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Policy} returns this
 */
proto.saasphoto.Policy.prototype.setEft = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.Group.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.Group.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.Group} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.Group.toObject = function(includeInstance, msg) {
  var f, obj = {
    rSub: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pSub: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.Group}
 */
proto.saasphoto.Group.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.Group;
  return proto.saasphoto.Group.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.Group} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.Group}
 */
proto.saasphoto.Group.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRSub(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPSub(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.Group.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.Group.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.Group} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.Group.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRSub();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPSub();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string r_sub = 1;
 * @return {string}
 */
proto.saasphoto.Group.prototype.getRSub = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Group} returns this
 */
proto.saasphoto.Group.prototype.setRSub = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string p_sub = 2;
 * @return {string}
 */
proto.saasphoto.Group.prototype.getPSub = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Group} returns this
 */
proto.saasphoto.Group.prototype.setPSub = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.PoliciesList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.PoliciesList.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.PoliciesList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.PoliciesList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.PoliciesList.toObject = function(includeInstance, msg) {
  var f, obj = {
    policiesList: jspb.Message.toObjectList(msg.getPoliciesList(),
    proto.saasphoto.Policy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.PoliciesList}
 */
proto.saasphoto.PoliciesList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.PoliciesList;
  return proto.saasphoto.PoliciesList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.PoliciesList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.PoliciesList}
 */
proto.saasphoto.PoliciesList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.Policy;
      reader.readMessage(value,proto.saasphoto.Policy.deserializeBinaryFromReader);
      msg.addPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.PoliciesList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.PoliciesList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.PoliciesList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.PoliciesList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.Policy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Policy policies = 1;
 * @return {!Array<!proto.saasphoto.Policy>}
 */
proto.saasphoto.PoliciesList.prototype.getPoliciesList = function() {
  return /** @type{!Array<!proto.saasphoto.Policy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.Policy, 1));
};


/**
 * @param {!Array<!proto.saasphoto.Policy>} value
 * @return {!proto.saasphoto.PoliciesList} returns this
*/
proto.saasphoto.PoliciesList.prototype.setPoliciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.Policy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.Policy}
 */
proto.saasphoto.PoliciesList.prototype.addPolicies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.Policy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.PoliciesList} returns this
 */
proto.saasphoto.PoliciesList.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GroupsList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GroupsList.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GroupsList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GroupsList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GroupsList.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.saasphoto.Group.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GroupsList}
 */
proto.saasphoto.GroupsList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GroupsList;
  return proto.saasphoto.GroupsList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GroupsList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GroupsList}
 */
proto.saasphoto.GroupsList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.Group;
      reader.readMessage(value,proto.saasphoto.Group.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GroupsList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GroupsList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GroupsList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GroupsList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.Group.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Group groups = 1;
 * @return {!Array<!proto.saasphoto.Group>}
 */
proto.saasphoto.GroupsList.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.saasphoto.Group>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.Group, 1));
};


/**
 * @param {!Array<!proto.saasphoto.Group>} value
 * @return {!proto.saasphoto.GroupsList} returns this
*/
proto.saasphoto.GroupsList.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.Group=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.Group}
 */
proto.saasphoto.GroupsList.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.Group, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GroupsList} returns this
 */
proto.saasphoto.GroupsList.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetPolicy.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetPolicy.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetPolicy} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPolicy.toObject = function(includeInstance, msg) {
  var f, obj = {
    sub: jspb.Message.getFieldWithDefault(msg, 1, ""),
    obj: jspb.Message.getFieldWithDefault(msg, 2, ""),
    act: jspb.Message.getFieldWithDefault(msg, 3, ""),
    eft: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetPolicy}
 */
proto.saasphoto.GetPolicy.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetPolicy;
  return proto.saasphoto.GetPolicy.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetPolicy} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetPolicy}
 */
proto.saasphoto.GetPolicy.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setSub(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setObj(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAct(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEft(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetPolicy.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetPolicy.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetPolicy} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPolicy.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSub();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getObj();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAct();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEft();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional string sub = 1;
 * @return {string}
 */
proto.saasphoto.GetPolicy.prototype.getSub = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetPolicy} returns this
 */
proto.saasphoto.GetPolicy.prototype.setSub = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string obj = 2;
 * @return {string}
 */
proto.saasphoto.GetPolicy.prototype.getObj = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetPolicy} returns this
 */
proto.saasphoto.GetPolicy.prototype.setObj = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string act = 3;
 * @return {string}
 */
proto.saasphoto.GetPolicy.prototype.getAct = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetPolicy} returns this
 */
proto.saasphoto.GetPolicy.prototype.setAct = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string eft = 4;
 * @return {string}
 */
proto.saasphoto.GetPolicy.prototype.getEft = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetPolicy} returns this
 */
proto.saasphoto.GetPolicy.prototype.setEft = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetGroup.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetGroup.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetGroup} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetGroup.toObject = function(includeInstance, msg) {
  var f, obj = {
    rSub: jspb.Message.getFieldWithDefault(msg, 1, ""),
    pSub: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetGroup}
 */
proto.saasphoto.GetGroup.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetGroup;
  return proto.saasphoto.GetGroup.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetGroup} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetGroup}
 */
proto.saasphoto.GetGroup.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setRSub(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPSub(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetGroup.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetGroup.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetGroup} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetGroup.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getRSub();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPSub();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string r_sub = 1;
 * @return {string}
 */
proto.saasphoto.GetGroup.prototype.getRSub = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetGroup} returns this
 */
proto.saasphoto.GetGroup.prototype.setRSub = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string p_sub = 2;
 * @return {string}
 */
proto.saasphoto.GetGroup.prototype.getPSub = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetGroup} returns this
 */
proto.saasphoto.GetGroup.prototype.setPSub = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetPoliciesList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetPoliciesList.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetPoliciesList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetPoliciesList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPoliciesList.toObject = function(includeInstance, msg) {
  var f, obj = {
    policiesList: jspb.Message.toObjectList(msg.getPoliciesList(),
    proto.saasphoto.GetPolicy.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetPoliciesList}
 */
proto.saasphoto.GetPoliciesList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetPoliciesList;
  return proto.saasphoto.GetPoliciesList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetPoliciesList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetPoliciesList}
 */
proto.saasphoto.GetPoliciesList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.GetPolicy;
      reader.readMessage(value,proto.saasphoto.GetPolicy.deserializeBinaryFromReader);
      msg.addPolicies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetPoliciesList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetPoliciesList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetPoliciesList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPoliciesList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPoliciesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.GetPolicy.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GetPolicy policies = 1;
 * @return {!Array<!proto.saasphoto.GetPolicy>}
 */
proto.saasphoto.GetPoliciesList.prototype.getPoliciesList = function() {
  return /** @type{!Array<!proto.saasphoto.GetPolicy>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.GetPolicy, 1));
};


/**
 * @param {!Array<!proto.saasphoto.GetPolicy>} value
 * @return {!proto.saasphoto.GetPoliciesList} returns this
*/
proto.saasphoto.GetPoliciesList.prototype.setPoliciesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.GetPolicy=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.GetPolicy}
 */
proto.saasphoto.GetPoliciesList.prototype.addPolicies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.GetPolicy, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetPoliciesList} returns this
 */
proto.saasphoto.GetPoliciesList.prototype.clearPoliciesList = function() {
  return this.setPoliciesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetGroupsList.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetGroupsList.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetGroupsList.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetGroupsList} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetGroupsList.toObject = function(includeInstance, msg) {
  var f, obj = {
    groupsList: jspb.Message.toObjectList(msg.getGroupsList(),
    proto.saasphoto.GetGroup.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetGroupsList}
 */
proto.saasphoto.GetGroupsList.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetGroupsList;
  return proto.saasphoto.GetGroupsList.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetGroupsList} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetGroupsList}
 */
proto.saasphoto.GetGroupsList.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.GetGroup;
      reader.readMessage(value,proto.saasphoto.GetGroup.deserializeBinaryFromReader);
      msg.addGroups(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetGroupsList.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetGroupsList.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetGroupsList} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetGroupsList.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGroupsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.GetGroup.serializeBinaryToWriter
    );
  }
};


/**
 * repeated GetGroup groups = 1;
 * @return {!Array<!proto.saasphoto.GetGroup>}
 */
proto.saasphoto.GetGroupsList.prototype.getGroupsList = function() {
  return /** @type{!Array<!proto.saasphoto.GetGroup>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.GetGroup, 1));
};


/**
 * @param {!Array<!proto.saasphoto.GetGroup>} value
 * @return {!proto.saasphoto.GetGroupsList} returns this
*/
proto.saasphoto.GetGroupsList.prototype.setGroupsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.GetGroup=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.GetGroup}
 */
proto.saasphoto.GetGroupsList.prototype.addGroups = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.GetGroup, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetGroupsList} returns this
 */
proto.saasphoto.GetGroupsList.prototype.clearGroupsList = function() {
  return this.setGroupsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.AddSystemNotifyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.AddSystemNotifyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AddSystemNotifyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, ""),
    startTime: (f = msg.getStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    publish: jspb.Message.getBooleanFieldWithDefault(msg, 4, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.AddSystemNotifyRequest}
 */
proto.saasphoto.AddSystemNotifyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.AddSystemNotifyRequest;
  return proto.saasphoto.AddSystemNotifyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.AddSystemNotifyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.AddSystemNotifyRequest}
 */
proto.saasphoto.AddSystemNotifyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 2:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPublish(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.AddSystemNotifyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.AddSystemNotifyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AddSystemNotifyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPublish();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.AddSystemNotifyRequest} returns this
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional google.protobuf.Timestamp start_time = 2;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.getStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 2));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.AddSystemNotifyRequest} returns this
*/
proto.saasphoto.AddSystemNotifyRequest.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.AddSystemNotifyRequest} returns this
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 2) != null;
};


/**
 * optional google.protobuf.Timestamp end_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.AddSystemNotifyRequest} returns this
*/
proto.saasphoto.AddSystemNotifyRequest.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.AddSystemNotifyRequest} returns this
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional bool publish = 4;
 * @return {boolean}
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.getPublish = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saasphoto.AddSystemNotifyRequest} returns this
 */
proto.saasphoto.AddSystemNotifyRequest.prototype.setPublish = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.SystemNotifyDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.SystemNotifyDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.SystemNotifyDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SystemNotifyDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    message: jspb.Message.getFieldWithDefault(msg, 2, ""),
    startTime: (f = msg.getStartTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    endTime: (f = msg.getEndTime()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    publish: jspb.Message.getBooleanFieldWithDefault(msg, 5, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.SystemNotifyDetail}
 */
proto.saasphoto.SystemNotifyDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.SystemNotifyDetail;
  return proto.saasphoto.SystemNotifyDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.SystemNotifyDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.SystemNotifyDetail}
 */
proto.saasphoto.SystemNotifyDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStartTime(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEndTime(value);
      break;
    case 5:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setPublish(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.SystemNotifyDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.SystemNotifyDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.SystemNotifyDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SystemNotifyDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getStartTime();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEndTime();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPublish();
  if (f) {
    writer.writeBool(
      5,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.saasphoto.SystemNotifyDetail.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.SystemNotifyDetail} returns this
 */
proto.saasphoto.SystemNotifyDetail.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string message = 2;
 * @return {string}
 */
proto.saasphoto.SystemNotifyDetail.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SystemNotifyDetail} returns this
 */
proto.saasphoto.SystemNotifyDetail.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp start_time = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.SystemNotifyDetail.prototype.getStartTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.SystemNotifyDetail} returns this
*/
proto.saasphoto.SystemNotifyDetail.prototype.setStartTime = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.SystemNotifyDetail} returns this
 */
proto.saasphoto.SystemNotifyDetail.prototype.clearStartTime = function() {
  return this.setStartTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.SystemNotifyDetail.prototype.hasStartTime = function() {
  return jspb.Message.getField(this, 3) != null;
};


/**
 * optional google.protobuf.Timestamp end_time = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.SystemNotifyDetail.prototype.getEndTime = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.SystemNotifyDetail} returns this
*/
proto.saasphoto.SystemNotifyDetail.prototype.setEndTime = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.SystemNotifyDetail} returns this
 */
proto.saasphoto.SystemNotifyDetail.prototype.clearEndTime = function() {
  return this.setEndTime(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.SystemNotifyDetail.prototype.hasEndTime = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional bool publish = 5;
 * @return {boolean}
 */
proto.saasphoto.SystemNotifyDetail.prototype.getPublish = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 5, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saasphoto.SystemNotifyDetail} returns this
 */
proto.saasphoto.SystemNotifyDetail.prototype.setPublish = function(value) {
  return jspb.Message.setProto3BooleanField(this, 5, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetSystemNotifiesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetSystemNotifiesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetSystemNotifiesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetSystemNotifiesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetSystemNotifiesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemNotifiesList: jspb.Message.toObjectList(msg.getSystemNotifiesList(),
    proto.saasphoto.SystemNotifyDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetSystemNotifiesResponse}
 */
proto.saasphoto.GetSystemNotifiesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetSystemNotifiesResponse;
  return proto.saasphoto.GetSystemNotifiesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetSystemNotifiesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetSystemNotifiesResponse}
 */
proto.saasphoto.GetSystemNotifiesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.SystemNotifyDetail;
      reader.readMessage(value,proto.saasphoto.SystemNotifyDetail.deserializeBinaryFromReader);
      msg.addSystemNotifies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetSystemNotifiesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetSystemNotifiesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetSystemNotifiesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetSystemNotifiesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNotifiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.SystemNotifyDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SystemNotifyDetail system_notifies = 1;
 * @return {!Array<!proto.saasphoto.SystemNotifyDetail>}
 */
proto.saasphoto.GetSystemNotifiesResponse.prototype.getSystemNotifiesList = function() {
  return /** @type{!Array<!proto.saasphoto.SystemNotifyDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.SystemNotifyDetail, 1));
};


/**
 * @param {!Array<!proto.saasphoto.SystemNotifyDetail>} value
 * @return {!proto.saasphoto.GetSystemNotifiesResponse} returns this
*/
proto.saasphoto.GetSystemNotifiesResponse.prototype.setSystemNotifiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.SystemNotifyDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.SystemNotifyDetail}
 */
proto.saasphoto.GetSystemNotifiesResponse.prototype.addSystemNotifies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.SystemNotifyDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetSystemNotifiesResponse} returns this
 */
proto.saasphoto.GetSystemNotifiesResponse.prototype.clearSystemNotifiesList = function() {
  return this.setSystemNotifiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.DeleteSystemNotifyRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.DeleteSystemNotifyRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.DeleteSystemNotifyRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.DeleteSystemNotifyRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.DeleteSystemNotifyRequest}
 */
proto.saasphoto.DeleteSystemNotifyRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.DeleteSystemNotifyRequest;
  return proto.saasphoto.DeleteSystemNotifyRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.DeleteSystemNotifyRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.DeleteSystemNotifyRequest}
 */
proto.saasphoto.DeleteSystemNotifyRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.DeleteSystemNotifyRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.DeleteSystemNotifyRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.DeleteSystemNotifyRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.DeleteSystemNotifyRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.saasphoto.DeleteSystemNotifyRequest.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.DeleteSystemNotifyRequest} returns this
 */
proto.saasphoto.DeleteSystemNotifyRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.UpdateSystemNotifiesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.UpdateSystemNotifiesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.UpdateSystemNotifiesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.UpdateSystemNotifiesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.UpdateSystemNotifiesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    systemNotifiesList: jspb.Message.toObjectList(msg.getSystemNotifiesList(),
    proto.saasphoto.SystemNotifyDetail.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.UpdateSystemNotifiesRequest}
 */
proto.saasphoto.UpdateSystemNotifiesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.UpdateSystemNotifiesRequest;
  return proto.saasphoto.UpdateSystemNotifiesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.UpdateSystemNotifiesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.UpdateSystemNotifiesRequest}
 */
proto.saasphoto.UpdateSystemNotifiesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.SystemNotifyDetail;
      reader.readMessage(value,proto.saasphoto.SystemNotifyDetail.deserializeBinaryFromReader);
      msg.addSystemNotifies(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.UpdateSystemNotifiesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.UpdateSystemNotifiesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.UpdateSystemNotifiesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.UpdateSystemNotifiesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSystemNotifiesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.SystemNotifyDetail.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SystemNotifyDetail system_notifies = 1;
 * @return {!Array<!proto.saasphoto.SystemNotifyDetail>}
 */
proto.saasphoto.UpdateSystemNotifiesRequest.prototype.getSystemNotifiesList = function() {
  return /** @type{!Array<!proto.saasphoto.SystemNotifyDetail>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.SystemNotifyDetail, 1));
};


/**
 * @param {!Array<!proto.saasphoto.SystemNotifyDetail>} value
 * @return {!proto.saasphoto.UpdateSystemNotifiesRequest} returns this
*/
proto.saasphoto.UpdateSystemNotifiesRequest.prototype.setSystemNotifiesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.SystemNotifyDetail=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.SystemNotifyDetail}
 */
proto.saasphoto.UpdateSystemNotifiesRequest.prototype.addSystemNotifies = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.SystemNotifyDetail, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.UpdateSystemNotifiesRequest} returns this
 */
proto.saasphoto.UpdateSystemNotifiesRequest.prototype.clearSystemNotifiesList = function() {
  return this.setSystemNotifiesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.CreateAccountRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.CreateAccountRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.CreateAccountRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreateAccountRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    countryCode: jspb.Message.getFieldWithDefault(msg, 3, ""),
    planId: jspb.Message.getFieldWithDefault(msg, 4, 0),
    companyName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 8, ""),
    expiryDate: (f = msg.getExpiryDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.CreateAccountRequest}
 */
proto.saasphoto.CreateAccountRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.CreateAccountRequest;
  return proto.saasphoto.CreateAccountRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.CreateAccountRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.CreateAccountRequest}
 */
proto.saasphoto.CreateAccountRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountryCode(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPlanId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiryDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.CreateAccountRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.CreateAccountRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.CreateAccountRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreateAccountRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCountryCode();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getPlanId();
  if (f !== 0) {
    writer.writeUint32(
      4,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getExpiryDate();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.saasphoto.CreateAccountRequest.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.saasphoto.CreateAccountRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string country_code = 3;
 * @return {string}
 */
proto.saasphoto.CreateAccountRequest.prototype.getCountryCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setCountryCode = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional uint32 plan_id = 4;
 * @return {number}
 */
proto.saasphoto.CreateAccountRequest.prototype.getPlanId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setPlanId = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional string company_name = 5;
 * @return {string}
 */
proto.saasphoto.CreateAccountRequest.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string first_name = 6;
 * @return {string}
 */
proto.saasphoto.CreateAccountRequest.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string last_name = 7;
 * @return {string}
 */
proto.saasphoto.CreateAccountRequest.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string phone_number = 8;
 * @return {string}
 */
proto.saasphoto.CreateAccountRequest.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp expiry_date = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.CreateAccountRequest.prototype.getExpiryDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
*/
proto.saasphoto.CreateAccountRequest.prototype.setExpiryDate = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.CreateAccountRequest} returns this
 */
proto.saasphoto.CreateAccountRequest.prototype.clearExpiryDate = function() {
  return this.setExpiryDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.CreateAccountRequest.prototype.hasExpiryDate = function() {
  return jspb.Message.getField(this, 9) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.CreateAccountResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.CreateAccountResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.CreateAccountResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreateAccountResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    status: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.CreateAccountResponse}
 */
proto.saasphoto.CreateAccountResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.CreateAccountResponse;
  return proto.saasphoto.CreateAccountResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.CreateAccountResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.CreateAccountResponse}
 */
proto.saasphoto.CreateAccountResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.saasphoto.CreateAccountErrorCode} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.CreateAccountResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.CreateAccountResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.CreateAccountResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreateAccountResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
};


/**
 * optional CreateAccountErrorCode status = 1;
 * @return {!proto.saasphoto.CreateAccountErrorCode}
 */
proto.saasphoto.CreateAccountResponse.prototype.getStatus = function() {
  return /** @type {!proto.saasphoto.CreateAccountErrorCode} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.saasphoto.CreateAccountErrorCode} value
 * @return {!proto.saasphoto.CreateAccountResponse} returns this
 */
proto.saasphoto.CreateAccountResponse.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.SalesReportRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.SalesReportRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.SalesReportRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SalesReportRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    agent: jspb.Message.getFieldWithDefault(msg, 1, ""),
    year: jspb.Message.getFieldWithDefault(msg, 2, 0),
    month: jspb.Message.getFieldWithDefault(msg, 3, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.SalesReportRequest}
 */
proto.saasphoto.SalesReportRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.SalesReportRequest;
  return proto.saasphoto.SalesReportRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.SalesReportRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.SalesReportRequest}
 */
proto.saasphoto.SalesReportRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgent(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setYear(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setMonth(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.SalesReportRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.SalesReportRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.SalesReportRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SalesReportRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAgent();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getYear();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getMonth();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
};


/**
 * optional string agent = 1;
 * @return {string}
 */
proto.saasphoto.SalesReportRequest.prototype.getAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReportRequest} returns this
 */
proto.saasphoto.SalesReportRequest.prototype.setAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int32 year = 2;
 * @return {number}
 */
proto.saasphoto.SalesReportRequest.prototype.getYear = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.SalesReportRequest} returns this
 */
proto.saasphoto.SalesReportRequest.prototype.setYear = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 month = 3;
 * @return {number}
 */
proto.saasphoto.SalesReportRequest.prototype.getMonth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.SalesReportRequest} returns this
 */
proto.saasphoto.SalesReportRequest.prototype.setMonth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.SalesReportResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.SalesReportResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.SalesReportResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.SalesReportResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SalesReportResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    salesReportList: jspb.Message.toObjectList(msg.getSalesReportList(),
    proto.saasphoto.SalesReport.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.SalesReportResponse}
 */
proto.saasphoto.SalesReportResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.SalesReportResponse;
  return proto.saasphoto.SalesReportResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.SalesReportResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.SalesReportResponse}
 */
proto.saasphoto.SalesReportResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.SalesReport;
      reader.readMessage(value,proto.saasphoto.SalesReport.deserializeBinaryFromReader);
      msg.addSalesReport(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.SalesReportResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.SalesReportResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.SalesReportResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SalesReportResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSalesReportList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.SalesReport.serializeBinaryToWriter
    );
  }
};


/**
 * repeated SalesReport sales_report = 1;
 * @return {!Array<!proto.saasphoto.SalesReport>}
 */
proto.saasphoto.SalesReportResponse.prototype.getSalesReportList = function() {
  return /** @type{!Array<!proto.saasphoto.SalesReport>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.SalesReport, 1));
};


/**
 * @param {!Array<!proto.saasphoto.SalesReport>} value
 * @return {!proto.saasphoto.SalesReportResponse} returns this
*/
proto.saasphoto.SalesReportResponse.prototype.setSalesReportList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.SalesReport=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.SalesReport}
 */
proto.saasphoto.SalesReportResponse.prototype.addSalesReport = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.SalesReport, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.SalesReportResponse} returns this
 */
proto.saasphoto.SalesReportResponse.prototype.clearSalesReportList = function() {
  return this.setSalesReportList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.SalesReport.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.SalesReport.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.SalesReport} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SalesReport.toObject = function(includeInstance, msg) {
  var f, obj = {
    type: jspb.Message.getFieldWithDefault(msg, 1, ""),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    chargeId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    planName: jspb.Message.getFieldWithDefault(msg, 5, ""),
    refillBandwidthSize: jspb.Message.getFieldWithDefault(msg, 6, 0),
    totalPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    recurring: jspb.Message.getBooleanFieldWithDefault(msg, 8, false),
    discount: jspb.Message.getFloatingPointFieldWithDefault(msg, 9, 0.0),
    creditCard: jspb.Message.getFieldWithDefault(msg, 10, 0),
    cardHolder: jspb.Message.getFieldWithDefault(msg, 11, ""),
    addrLine1: jspb.Message.getFieldWithDefault(msg, 12, ""),
    addrLine2: jspb.Message.getFieldWithDefault(msg, 13, ""),
    city: jspb.Message.getFieldWithDefault(msg, 14, ""),
    state: jspb.Message.getFieldWithDefault(msg, 15, ""),
    zipCode: jspb.Message.getFieldWithDefault(msg, 16, ""),
    country: jspb.Message.getFieldWithDefault(msg, 17, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 18, ""),
    ip: jspb.Message.getFieldWithDefault(msg, 19, ""),
    agent: jspb.Message.getFieldWithDefault(msg, 20, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 21, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.SalesReport}
 */
proto.saasphoto.SalesReport.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.SalesReport;
  return proto.saasphoto.SalesReport.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.SalesReport} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.SalesReport}
 */
proto.saasphoto.SalesReport.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setType(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanName(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRefillBandwidthSize(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalPrice(value);
      break;
    case 8:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecurring(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDiscount(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCreditCard(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardHolder(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrLine1(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrLine2(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 16:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 18:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgent(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.SalesReport.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.SalesReport.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.SalesReport} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SalesReport.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getType();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChargeId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getPlanName();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRefillBandwidthSize();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getTotalPrice();
  if (f !== 0.0) {
    writer.writeFloat(
      7,
      f
    );
  }
  f = message.getRecurring();
  if (f) {
    writer.writeBool(
      8,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0.0) {
    writer.writeFloat(
      9,
      f
    );
  }
  f = message.getCreditCard();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
  f = message.getCardHolder();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getAddrLine1();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAddrLine2();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      16,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      18,
      f
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
  f = message.getAgent();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getCreatedAt();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
};


/**
 * optional string type = 1;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setType = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string charge_id = 3;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getChargeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setChargeId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string subscription_id = 4;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string plan_name = 5;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 refill_bandwidth_size = 6;
 * @return {number}
 */
proto.saasphoto.SalesReport.prototype.getRefillBandwidthSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setRefillBandwidthSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional float total_price = 7;
 * @return {number}
 */
proto.saasphoto.SalesReport.prototype.getTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setTotalPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional bool recurring = 8;
 * @return {boolean}
 */
proto.saasphoto.SalesReport.prototype.getRecurring = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 8, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setRecurring = function(value) {
  return jspb.Message.setProto3BooleanField(this, 8, value);
};


/**
 * optional float discount = 9;
 * @return {number}
 */
proto.saasphoto.SalesReport.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 9, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3FloatField(this, 9, value);
};


/**
 * optional uint32 credit_card = 10;
 * @return {number}
 */
proto.saasphoto.SalesReport.prototype.getCreditCard = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setCreditCard = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional string card_holder = 11;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getCardHolder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setCardHolder = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string addr_line1 = 12;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getAddrLine1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setAddrLine1 = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string addr_line2 = 13;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getAddrLine2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setAddrLine2 = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string city = 14;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string state = 15;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional string zip_code = 16;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 16, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 16, value);
};


/**
 * optional string country = 17;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional string phone_number = 18;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 18, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 18, value);
};


/**
 * optional string ip = 19;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};


/**
 * optional string agent = 20;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string created_at = 21;
 * @return {string}
 */
proto.saasphoto.SalesReport.prototype.getCreatedAt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SalesReport} returns this
 */
proto.saasphoto.SalesReport.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetAgentsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetAgentsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetAgentsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetAgentsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetAgentsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetAgentsResponse}
 */
proto.saasphoto.GetAgentsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetAgentsResponse;
  return proto.saasphoto.GetAgentsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetAgentsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetAgentsResponse}
 */
proto.saasphoto.GetAgentsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetAgentsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetAgentsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetAgentsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetAgentsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string list = 1;
 * @return {!Array<string>}
 */
proto.saasphoto.GetAgentsResponse.prototype.getListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.saasphoto.GetAgentsResponse} returns this
 */
proto.saasphoto.GetAgentsResponse.prototype.setListList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.GetAgentsResponse} returns this
 */
proto.saasphoto.GetAgentsResponse.prototype.addList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetAgentsResponse} returns this
 */
proto.saasphoto.GetAgentsResponse.prototype.clearListList = function() {
  return this.setListList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetAccountTypesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetAccountTypesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetAccountTypesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetAccountTypesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetAccountTypesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    listList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetAccountTypesResponse}
 */
proto.saasphoto.GetAccountTypesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetAccountTypesResponse;
  return proto.saasphoto.GetAccountTypesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetAccountTypesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetAccountTypesResponse}
 */
proto.saasphoto.GetAccountTypesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addList(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetAccountTypesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetAccountTypesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetAccountTypesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetAccountTypesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getListList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
};


/**
 * repeated string list = 1;
 * @return {!Array<string>}
 */
proto.saasphoto.GetAccountTypesResponse.prototype.getListList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.saasphoto.GetAccountTypesResponse} returns this
 */
proto.saasphoto.GetAccountTypesResponse.prototype.setListList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.GetAccountTypesResponse} returns this
 */
proto.saasphoto.GetAccountTypesResponse.prototype.addList = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetAccountTypesResponse} returns this
 */
proto.saasphoto.GetAccountTypesResponse.prototype.clearListList = function() {
  return this.setListList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.SearchRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.SearchRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.SearchRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SearchRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    keyword: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountType: jspb.Message.getFieldWithDefault(msg, 2, ""),
    agent: jspb.Message.getFieldWithDefault(msg, 3, ""),
    start: (f = msg.getStart()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    end: (f = msg.getEnd()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.SearchRequest}
 */
proto.saasphoto.SearchRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.SearchRequest;
  return proto.saasphoto.SearchRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.SearchRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.SearchRequest}
 */
proto.saasphoto.SearchRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKeyword(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgent(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setStart(value);
      break;
    case 5:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.SearchRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.SearchRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.SearchRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SearchRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKeyword();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAgent();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getStart();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getEnd();
  if (f != null) {
    writer.writeMessage(
      5,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string keyword = 1;
 * @return {string}
 */
proto.saasphoto.SearchRequest.prototype.getKeyword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SearchRequest} returns this
 */
proto.saasphoto.SearchRequest.prototype.setKeyword = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_type = 2;
 * @return {string}
 */
proto.saasphoto.SearchRequest.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SearchRequest} returns this
 */
proto.saasphoto.SearchRequest.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string agent = 3;
 * @return {string}
 */
proto.saasphoto.SearchRequest.prototype.getAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SearchRequest} returns this
 */
proto.saasphoto.SearchRequest.prototype.setAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp start = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.SearchRequest.prototype.getStart = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.SearchRequest} returns this
*/
proto.saasphoto.SearchRequest.prototype.setStart = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.SearchRequest} returns this
 */
proto.saasphoto.SearchRequest.prototype.clearStart = function() {
  return this.setStart(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.SearchRequest.prototype.hasStart = function() {
  return jspb.Message.getField(this, 4) != null;
};


/**
 * optional google.protobuf.Timestamp end = 5;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.SearchRequest.prototype.getEnd = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 5));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.SearchRequest} returns this
*/
proto.saasphoto.SearchRequest.prototype.setEnd = function(value) {
  return jspb.Message.setWrapperField(this, 5, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.SearchRequest} returns this
 */
proto.saasphoto.SearchRequest.prototype.clearEnd = function() {
  return this.setEnd(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.SearchRequest.prototype.hasEnd = function() {
  return jspb.Message.getField(this, 5) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.SearchResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.SearchResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.SearchResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.SearchResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SearchResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.saasphoto.User.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.SearchResponse}
 */
proto.saasphoto.SearchResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.SearchResponse;
  return proto.saasphoto.SearchResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.SearchResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.SearchResponse}
 */
proto.saasphoto.SearchResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.User;
      reader.readMessage(value,proto.saasphoto.User.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.SearchResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.SearchResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.SearchResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SearchResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.User.serializeBinaryToWriter
    );
  }
};


/**
 * repeated User users = 1;
 * @return {!Array<!proto.saasphoto.User>}
 */
proto.saasphoto.SearchResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.saasphoto.User>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.User, 1));
};


/**
 * @param {!Array<!proto.saasphoto.User>} value
 * @return {!proto.saasphoto.SearchResponse} returns this
*/
proto.saasphoto.SearchResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.User=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.User}
 */
proto.saasphoto.SearchResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.User, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.SearchResponse} returns this
 */
proto.saasphoto.SearchResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.User.repeatedFields_ = [11];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.User.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.User.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.User} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.User.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    key: jspb.Message.getFieldWithDefault(msg, 3, ""),
    accountType: jspb.Message.getFieldWithDefault(msg, 4, ""),
    status: jspb.Message.getFieldWithDefault(msg, 5, 0),
    agent: jspb.Message.getFieldWithDefault(msg, 6, ""),
    companyName: jspb.Message.getFieldWithDefault(msg, 7, ""),
    firstName: jspb.Message.getFieldWithDefault(msg, 8, ""),
    lastName: jspb.Message.getFieldWithDefault(msg, 9, ""),
    phoneNumber: jspb.Message.getFieldWithDefault(msg, 10, ""),
    transactionsList: jspb.Message.toObjectList(msg.getTransactionsList(),
    proto.saasphoto.Transaction.toObject, includeInstance),
    latestPlan: (f = msg.getLatestPlan()) && proto.saasphoto.LatestPlan.toObject(includeInstance, f),
    updatedAt: (f = msg.getUpdatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    usageDetail: (f = msg.getUsageDetail()) && proto.saasphoto.UsageDetail.toObject(includeInstance, f),
    orteryDirect: (f = msg.getOrteryDirect()) && proto.saasphoto.OrteryDirect.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.User}
 */
proto.saasphoto.User.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.User;
  return proto.saasphoto.User.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.User} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.User}
 */
proto.saasphoto.User.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountType(value);
      break;
    case 5:
      var value = /** @type {!proto.saasphoto.CustomerErrorCode} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setAgent(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setCompanyName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setFirstName(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setLastName(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setPhoneNumber(value);
      break;
    case 11:
      var value = new proto.saasphoto.Transaction;
      reader.readMessage(value,proto.saasphoto.Transaction.deserializeBinaryFromReader);
      msg.addTransactions(value);
      break;
    case 12:
      var value = new proto.saasphoto.LatestPlan;
      reader.readMessage(value,proto.saasphoto.LatestPlan.deserializeBinaryFromReader);
      msg.setLatestPlan(value);
      break;
    case 13:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setUpdatedAt(value);
      break;
    case 14:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 15:
      var value = new proto.saasphoto.UsageDetail;
      reader.readMessage(value,proto.saasphoto.UsageDetail.deserializeBinaryFromReader);
      msg.setUsageDetail(value);
      break;
    case 16:
      var value = new proto.saasphoto.OrteryDirect;
      reader.readMessage(value,proto.saasphoto.OrteryDirect.deserializeBinaryFromReader);
      msg.setOrteryDirect(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.User.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.User.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.User} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.User.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getAccountType();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      5,
      f
    );
  }
  f = message.getAgent();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getCompanyName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getFirstName();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getLastName();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getPhoneNumber();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getTransactionsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      11,
      f,
      proto.saasphoto.Transaction.serializeBinaryToWriter
    );
  }
  f = message.getLatestPlan();
  if (f != null) {
    writer.writeMessage(
      12,
      f,
      proto.saasphoto.LatestPlan.serializeBinaryToWriter
    );
  }
  f = message.getUpdatedAt();
  if (f != null) {
    writer.writeMessage(
      13,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      14,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getUsageDetail();
  if (f != null) {
    writer.writeMessage(
      15,
      f,
      proto.saasphoto.UsageDetail.serializeBinaryToWriter
    );
  }
  f = message.getOrteryDirect();
  if (f != null) {
    writer.writeMessage(
      16,
      f,
      proto.saasphoto.OrteryDirect.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.saasphoto.User.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.saasphoto.User.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string key = 3;
 * @return {string}
 */
proto.saasphoto.User.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string account_type = 4;
 * @return {string}
 */
proto.saasphoto.User.prototype.getAccountType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setAccountType = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional CustomerErrorCode status = 5;
 * @return {!proto.saasphoto.CustomerErrorCode}
 */
proto.saasphoto.User.prototype.getStatus = function() {
  return /** @type {!proto.saasphoto.CustomerErrorCode} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {!proto.saasphoto.CustomerErrorCode} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 5, value);
};


/**
 * optional string agent = 6;
 * @return {string}
 */
proto.saasphoto.User.prototype.getAgent = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setAgent = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string company_name = 7;
 * @return {string}
 */
proto.saasphoto.User.prototype.getCompanyName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setCompanyName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string first_name = 8;
 * @return {string}
 */
proto.saasphoto.User.prototype.getFirstName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setFirstName = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string last_name = 9;
 * @return {string}
 */
proto.saasphoto.User.prototype.getLastName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setLastName = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string phone_number = 10;
 * @return {string}
 */
proto.saasphoto.User.prototype.getPhoneNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.setPhoneNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated Transaction transactions = 11;
 * @return {!Array<!proto.saasphoto.Transaction>}
 */
proto.saasphoto.User.prototype.getTransactionsList = function() {
  return /** @type{!Array<!proto.saasphoto.Transaction>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.Transaction, 11));
};


/**
 * @param {!Array<!proto.saasphoto.Transaction>} value
 * @return {!proto.saasphoto.User} returns this
*/
proto.saasphoto.User.prototype.setTransactionsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 11, value);
};


/**
 * @param {!proto.saasphoto.Transaction=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.Transaction}
 */
proto.saasphoto.User.prototype.addTransactions = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 11, opt_value, proto.saasphoto.Transaction, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.clearTransactionsList = function() {
  return this.setTransactionsList([]);
};


/**
 * optional LatestPlan latest_plan = 12;
 * @return {?proto.saasphoto.LatestPlan}
 */
proto.saasphoto.User.prototype.getLatestPlan = function() {
  return /** @type{?proto.saasphoto.LatestPlan} */ (
    jspb.Message.getWrapperField(this, proto.saasphoto.LatestPlan, 12));
};


/**
 * @param {?proto.saasphoto.LatestPlan|undefined} value
 * @return {!proto.saasphoto.User} returns this
*/
proto.saasphoto.User.prototype.setLatestPlan = function(value) {
  return jspb.Message.setWrapperField(this, 12, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.clearLatestPlan = function() {
  return this.setLatestPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.User.prototype.hasLatestPlan = function() {
  return jspb.Message.getField(this, 12) != null;
};


/**
 * optional google.protobuf.Timestamp updated_at = 13;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.User.prototype.getUpdatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 13));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.User} returns this
*/
proto.saasphoto.User.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 13, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.clearUpdatedAt = function() {
  return this.setUpdatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.User.prototype.hasUpdatedAt = function() {
  return jspb.Message.getField(this, 13) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 14;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.User.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 14));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.User} returns this
*/
proto.saasphoto.User.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 14, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.User.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 14) != null;
};


/**
 * optional UsageDetail usage_detail = 15;
 * @return {?proto.saasphoto.UsageDetail}
 */
proto.saasphoto.User.prototype.getUsageDetail = function() {
  return /** @type{?proto.saasphoto.UsageDetail} */ (
    jspb.Message.getWrapperField(this, proto.saasphoto.UsageDetail, 15));
};


/**
 * @param {?proto.saasphoto.UsageDetail|undefined} value
 * @return {!proto.saasphoto.User} returns this
*/
proto.saasphoto.User.prototype.setUsageDetail = function(value) {
  return jspb.Message.setWrapperField(this, 15, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.clearUsageDetail = function() {
  return this.setUsageDetail(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.User.prototype.hasUsageDetail = function() {
  return jspb.Message.getField(this, 15) != null;
};


/**
 * optional OrteryDirect ortery_direct = 16;
 * @return {?proto.saasphoto.OrteryDirect}
 */
proto.saasphoto.User.prototype.getOrteryDirect = function() {
  return /** @type{?proto.saasphoto.OrteryDirect} */ (
    jspb.Message.getWrapperField(this, proto.saasphoto.OrteryDirect, 16));
};


/**
 * @param {?proto.saasphoto.OrteryDirect|undefined} value
 * @return {!proto.saasphoto.User} returns this
*/
proto.saasphoto.User.prototype.setOrteryDirect = function(value) {
  return jspb.Message.setWrapperField(this, 16, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.User} returns this
 */
proto.saasphoto.User.prototype.clearOrteryDirect = function() {
  return this.setOrteryDirect(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.User.prototype.hasOrteryDirect = function() {
  return jspb.Message.getField(this, 16) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.OrteryDirect.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.OrteryDirect.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.OrteryDirect} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.OrteryDirect.toObject = function(includeInstance, msg) {
  var f, obj = {
    storeName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    installed: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    moduleType: jspb.Message.getFieldWithDefault(msg, 3, ""),
    expiryDate: (f = msg.getExpiryDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.OrteryDirect}
 */
proto.saasphoto.OrteryDirect.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.OrteryDirect;
  return proto.saasphoto.OrteryDirect.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.OrteryDirect} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.OrteryDirect}
 */
proto.saasphoto.OrteryDirect.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setStoreName(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setInstalled(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setModuleType(value);
      break;
    case 4:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiryDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.OrteryDirect.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.OrteryDirect.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.OrteryDirect} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.OrteryDirect.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStoreName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getInstalled();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getModuleType();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getExpiryDate();
  if (f != null) {
    writer.writeMessage(
      4,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional string store_name = 1;
 * @return {string}
 */
proto.saasphoto.OrteryDirect.prototype.getStoreName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.OrteryDirect} returns this
 */
proto.saasphoto.OrteryDirect.prototype.setStoreName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool installed = 2;
 * @return {boolean}
 */
proto.saasphoto.OrteryDirect.prototype.getInstalled = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saasphoto.OrteryDirect} returns this
 */
proto.saasphoto.OrteryDirect.prototype.setInstalled = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string module_type = 3;
 * @return {string}
 */
proto.saasphoto.OrteryDirect.prototype.getModuleType = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.OrteryDirect} returns this
 */
proto.saasphoto.OrteryDirect.prototype.setModuleType = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional google.protobuf.Timestamp expiry_date = 4;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.OrteryDirect.prototype.getExpiryDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 4));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.OrteryDirect} returns this
*/
proto.saasphoto.OrteryDirect.prototype.setExpiryDate = function(value) {
  return jspb.Message.setWrapperField(this, 4, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.OrteryDirect} returns this
 */
proto.saasphoto.OrteryDirect.prototype.clearExpiryDate = function() {
  return this.setExpiryDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.OrteryDirect.prototype.hasExpiryDate = function() {
  return jspb.Message.getField(this, 4) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.LatestPlan.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.LatestPlan.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.LatestPlan} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.LatestPlan.toObject = function(includeInstance, msg) {
  var f, obj = {
    hostingPlan: (f = msg.getHostingPlan()) && protocol_customer_pb.GetLatestUserPlanResponse.toObject(includeInstance, f),
    aiPlan: (f = msg.getAiPlan()) && protocol_customer_pb.GetLatestUserPlanResponse.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.LatestPlan}
 */
proto.saasphoto.LatestPlan.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.LatestPlan;
  return proto.saasphoto.LatestPlan.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.LatestPlan} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.LatestPlan}
 */
proto.saasphoto.LatestPlan.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new protocol_customer_pb.GetLatestUserPlanResponse;
      reader.readMessage(value,protocol_customer_pb.GetLatestUserPlanResponse.deserializeBinaryFromReader);
      msg.setHostingPlan(value);
      break;
    case 2:
      var value = new protocol_customer_pb.GetLatestUserPlanResponse;
      reader.readMessage(value,protocol_customer_pb.GetLatestUserPlanResponse.deserializeBinaryFromReader);
      msg.setAiPlan(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.LatestPlan.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.LatestPlan.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.LatestPlan} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.LatestPlan.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getHostingPlan();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      protocol_customer_pb.GetLatestUserPlanResponse.serializeBinaryToWriter
    );
  }
  f = message.getAiPlan();
  if (f != null) {
    writer.writeMessage(
      2,
      f,
      protocol_customer_pb.GetLatestUserPlanResponse.serializeBinaryToWriter
    );
  }
};


/**
 * optional GetLatestUserPlanResponse hosting_plan = 1;
 * @return {?proto.saasphoto.GetLatestUserPlanResponse}
 */
proto.saasphoto.LatestPlan.prototype.getHostingPlan = function() {
  return /** @type{?proto.saasphoto.GetLatestUserPlanResponse} */ (
    jspb.Message.getWrapperField(this, protocol_customer_pb.GetLatestUserPlanResponse, 1));
};


/**
 * @param {?proto.saasphoto.GetLatestUserPlanResponse|undefined} value
 * @return {!proto.saasphoto.LatestPlan} returns this
*/
proto.saasphoto.LatestPlan.prototype.setHostingPlan = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.LatestPlan} returns this
 */
proto.saasphoto.LatestPlan.prototype.clearHostingPlan = function() {
  return this.setHostingPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.LatestPlan.prototype.hasHostingPlan = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional GetLatestUserPlanResponse ai_plan = 2;
 * @return {?proto.saasphoto.GetLatestUserPlanResponse}
 */
proto.saasphoto.LatestPlan.prototype.getAiPlan = function() {
  return /** @type{?proto.saasphoto.GetLatestUserPlanResponse} */ (
    jspb.Message.getWrapperField(this, protocol_customer_pb.GetLatestUserPlanResponse, 2));
};


/**
 * @param {?proto.saasphoto.GetLatestUserPlanResponse|undefined} value
 * @return {!proto.saasphoto.LatestPlan} returns this
*/
proto.saasphoto.LatestPlan.prototype.setAiPlan = function(value) {
  return jspb.Message.setWrapperField(this, 2, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.LatestPlan} returns this
 */
proto.saasphoto.LatestPlan.prototype.clearAiPlan = function() {
  return this.setAiPlan(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.LatestPlan.prototype.hasAiPlan = function() {
  return jspb.Message.getField(this, 2) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.Transaction.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.Transaction.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.Transaction} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.Transaction.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, 0),
    name: jspb.Message.getFieldWithDefault(msg, 3, 0),
    chargeId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    subscriptionId: jspb.Message.getFieldWithDefault(msg, 5, ""),
    refillBandwidthSize: jspb.Message.getFieldWithDefault(msg, 6, 0),
    creditCard: jspb.Message.getFieldWithDefault(msg, 7, 0),
    cardHolder: jspb.Message.getFieldWithDefault(msg, 8, ""),
    city: jspb.Message.getFieldWithDefault(msg, 9, ""),
    country: jspb.Message.getFieldWithDefault(msg, 10, ""),
    zipCode: jspb.Message.getFieldWithDefault(msg, 11, ""),
    state: jspb.Message.getFieldWithDefault(msg, 12, ""),
    addrLine1: jspb.Message.getFieldWithDefault(msg, 13, ""),
    addrLine2: jspb.Message.getFieldWithDefault(msg, 14, ""),
    ip: jspb.Message.getFieldWithDefault(msg, 15, ""),
    recurring: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    recurringCancelAt: jspb.Message.getFieldWithDefault(msg, 17, 0),
    totalPrice: jspb.Message.getFloatingPointFieldWithDefault(msg, 18, 0.0),
    discount: jspb.Message.getFloatingPointFieldWithDefault(msg, 19, 0.0),
    receiptNumber: jspb.Message.getFieldWithDefault(msg, 20, ""),
    receiptUrl: jspb.Message.getFieldWithDefault(msg, 21, ""),
    planPricing: (f = msg.getPlanPricing()) && protocol_plan_pb.PlanPricingDetail.toObject(includeInstance, f),
    createdAt: (f = msg.getCreatedAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    expiryDate: (f = msg.getExpiryDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    planType: jspb.Message.getFieldWithDefault(msg, 25, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.Transaction}
 */
proto.saasphoto.Transaction.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.Transaction;
  return proto.saasphoto.Transaction.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.Transaction} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.Transaction}
 */
proto.saasphoto.Transaction.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setId(value);
      break;
    case 3:
      var value = /** @type {!proto.saasphoto.TransactionName} */ (reader.readEnum());
      msg.setName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChargeId(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSubscriptionId(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRefillBandwidthSize(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setCreditCard(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCardHolder(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setCity(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setCountry(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setZipCode(value);
      break;
    case 12:
      var value = /** @type {string} */ (reader.readString());
      msg.setState(value);
      break;
    case 13:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrLine1(value);
      break;
    case 14:
      var value = /** @type {string} */ (reader.readString());
      msg.setAddrLine2(value);
      break;
    case 15:
      var value = /** @type {string} */ (reader.readString());
      msg.setIp(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setRecurring(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setRecurringCancelAt(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setTotalPrice(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDiscount(value);
      break;
    case 20:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptNumber(value);
      break;
    case 21:
      var value = /** @type {string} */ (reader.readString());
      msg.setReceiptUrl(value);
      break;
    case 22:
      var value = new protocol_plan_pb.PlanPricingDetail;
      reader.readMessage(value,protocol_plan_pb.PlanPricingDetail.deserializeBinaryFromReader);
      msg.setPlanPricing(value);
      break;
    case 23:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setCreatedAt(value);
      break;
    case 24:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiryDate(value);
      break;
    case 25:
      var value = /** @type {!proto.saasphoto.PlanType} */ (reader.readEnum());
      msg.setPlanType(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.Transaction.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.Transaction.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.Transaction} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.Transaction.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getName();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getChargeId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSubscriptionId();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getRefillBandwidthSize();
  if (f !== 0) {
    writer.writeUint32(
      6,
      f
    );
  }
  f = message.getCreditCard();
  if (f !== 0) {
    writer.writeUint32(
      7,
      f
    );
  }
  f = message.getCardHolder();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getCity();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getCountry();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getZipCode();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getState();
  if (f.length > 0) {
    writer.writeString(
      12,
      f
    );
  }
  f = message.getAddrLine1();
  if (f.length > 0) {
    writer.writeString(
      13,
      f
    );
  }
  f = message.getAddrLine2();
  if (f.length > 0) {
    writer.writeString(
      14,
      f
    );
  }
  f = message.getIp();
  if (f.length > 0) {
    writer.writeString(
      15,
      f
    );
  }
  f = message.getRecurring();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getRecurringCancelAt();
  if (f !== 0) {
    writer.writeUint32(
      17,
      f
    );
  }
  f = message.getTotalPrice();
  if (f !== 0.0) {
    writer.writeFloat(
      18,
      f
    );
  }
  f = message.getDiscount();
  if (f !== 0.0) {
    writer.writeFloat(
      19,
      f
    );
  }
  f = message.getReceiptNumber();
  if (f.length > 0) {
    writer.writeString(
      20,
      f
    );
  }
  f = message.getReceiptUrl();
  if (f.length > 0) {
    writer.writeString(
      21,
      f
    );
  }
  f = message.getPlanPricing();
  if (f != null) {
    writer.writeMessage(
      22,
      f,
      protocol_plan_pb.PlanPricingDetail.serializeBinaryToWriter
    );
  }
  f = message.getCreatedAt();
  if (f != null) {
    writer.writeMessage(
      23,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getExpiryDate();
  if (f != null) {
    writer.writeMessage(
      24,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPlanType();
  if (f !== 0.0) {
    writer.writeEnum(
      25,
      f
    );
  }
};


/**
 * optional uint32 id = 1;
 * @return {number}
 */
proto.saasphoto.Transaction.prototype.getId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional TransactionName name = 3;
 * @return {!proto.saasphoto.TransactionName}
 */
proto.saasphoto.Transaction.prototype.getName = function() {
  return /** @type {!proto.saasphoto.TransactionName} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.saasphoto.TransactionName} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setName = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string charge_id = 4;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getChargeId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setChargeId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string subscription_id = 5;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getSubscriptionId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setSubscriptionId = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional uint32 refill_bandwidth_size = 6;
 * @return {number}
 */
proto.saasphoto.Transaction.prototype.getRefillBandwidthSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setRefillBandwidthSize = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional uint32 credit_card = 7;
 * @return {number}
 */
proto.saasphoto.Transaction.prototype.getCreditCard = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setCreditCard = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional string card_holder = 8;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getCardHolder = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setCardHolder = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string city = 9;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getCity = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setCity = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string country = 10;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getCountry = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setCountry = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * optional string zip_code = 11;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getZipCode = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setZipCode = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional string state = 12;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getState = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 12, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setState = function(value) {
  return jspb.Message.setProto3StringField(this, 12, value);
};


/**
 * optional string addr_line1 = 13;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getAddrLine1 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 13, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setAddrLine1 = function(value) {
  return jspb.Message.setProto3StringField(this, 13, value);
};


/**
 * optional string addr_line2 = 14;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getAddrLine2 = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 14, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setAddrLine2 = function(value) {
  return jspb.Message.setProto3StringField(this, 14, value);
};


/**
 * optional string ip = 15;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getIp = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 15, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setIp = function(value) {
  return jspb.Message.setProto3StringField(this, 15, value);
};


/**
 * optional bool recurring = 16;
 * @return {boolean}
 */
proto.saasphoto.Transaction.prototype.getRecurring = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setRecurring = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional uint32 recurring_cancel_at = 17;
 * @return {number}
 */
proto.saasphoto.Transaction.prototype.getRecurringCancelAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setRecurringCancelAt = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional float total_price = 18;
 * @return {number}
 */
proto.saasphoto.Transaction.prototype.getTotalPrice = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 18, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setTotalPrice = function(value) {
  return jspb.Message.setProto3FloatField(this, 18, value);
};


/**
 * optional float discount = 19;
 * @return {number}
 */
proto.saasphoto.Transaction.prototype.getDiscount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 19, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setDiscount = function(value) {
  return jspb.Message.setProto3FloatField(this, 19, value);
};


/**
 * optional string receipt_number = 20;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getReceiptNumber = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 20, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setReceiptNumber = function(value) {
  return jspb.Message.setProto3StringField(this, 20, value);
};


/**
 * optional string receipt_url = 21;
 * @return {string}
 */
proto.saasphoto.Transaction.prototype.getReceiptUrl = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 21, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setReceiptUrl = function(value) {
  return jspb.Message.setProto3StringField(this, 21, value);
};


/**
 * optional PlanPricingDetail plan_pricing = 22;
 * @return {?proto.saasphoto.PlanPricingDetail}
 */
proto.saasphoto.Transaction.prototype.getPlanPricing = function() {
  return /** @type{?proto.saasphoto.PlanPricingDetail} */ (
    jspb.Message.getWrapperField(this, protocol_plan_pb.PlanPricingDetail, 22));
};


/**
 * @param {?proto.saasphoto.PlanPricingDetail|undefined} value
 * @return {!proto.saasphoto.Transaction} returns this
*/
proto.saasphoto.Transaction.prototype.setPlanPricing = function(value) {
  return jspb.Message.setWrapperField(this, 22, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.clearPlanPricing = function() {
  return this.setPlanPricing(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.Transaction.prototype.hasPlanPricing = function() {
  return jspb.Message.getField(this, 22) != null;
};


/**
 * optional google.protobuf.Timestamp created_at = 23;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.Transaction.prototype.getCreatedAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 23));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.Transaction} returns this
*/
proto.saasphoto.Transaction.prototype.setCreatedAt = function(value) {
  return jspb.Message.setWrapperField(this, 23, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.clearCreatedAt = function() {
  return this.setCreatedAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.Transaction.prototype.hasCreatedAt = function() {
  return jspb.Message.getField(this, 23) != null;
};


/**
 * optional google.protobuf.Timestamp expiry_date = 24;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.Transaction.prototype.getExpiryDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 24));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.Transaction} returns this
*/
proto.saasphoto.Transaction.prototype.setExpiryDate = function(value) {
  return jspb.Message.setWrapperField(this, 24, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.clearExpiryDate = function() {
  return this.setExpiryDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.Transaction.prototype.hasExpiryDate = function() {
  return jspb.Message.getField(this, 24) != null;
};


/**
 * optional PlanType plan_type = 25;
 * @return {!proto.saasphoto.PlanType}
 */
proto.saasphoto.Transaction.prototype.getPlanType = function() {
  return /** @type {!proto.saasphoto.PlanType} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {!proto.saasphoto.PlanType} value
 * @return {!proto.saasphoto.Transaction} returns this
 */
proto.saasphoto.Transaction.prototype.setPlanType = function(value) {
  return jspb.Message.setProto3EnumField(this, 25, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.UsageDetail.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.UsageDetail.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.UsageDetail} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.UsageDetail.toObject = function(includeInstance, msg) {
  var f, obj = {
    planBandwidth: jspb.Message.getFieldWithDefault(msg, 1, 0),
    planStorage: jspb.Message.getFieldWithDefault(msg, 2, 0),
    usedBandwidth: jspb.Message.getFieldWithDefault(msg, 3, 0),
    usedStorage: jspb.Message.getFieldWithDefault(msg, 4, 0),
    credit: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    usedCredit: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    planCredit: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    usedPlanCredit: jspb.Message.getFloatingPointFieldWithDefault(msg, 8, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.UsageDetail}
 */
proto.saasphoto.UsageDetail.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.UsageDetail;
  return proto.saasphoto.UsageDetail.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.UsageDetail} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.UsageDetail}
 */
proto.saasphoto.UsageDetail.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPlanBandwidth(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setPlanStorage(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUsedBandwidth(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readUint64());
      msg.setUsedStorage(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCredit(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUsedCredit(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setPlanCredit(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUsedPlanCredit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.UsageDetail.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.UsageDetail.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.UsageDetail} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.UsageDetail.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlanBandwidth();
  if (f !== 0) {
    writer.writeUint64(
      1,
      f
    );
  }
  f = message.getPlanStorage();
  if (f !== 0) {
    writer.writeUint64(
      2,
      f
    );
  }
  f = message.getUsedBandwidth();
  if (f !== 0) {
    writer.writeUint64(
      3,
      f
    );
  }
  f = message.getUsedStorage();
  if (f !== 0) {
    writer.writeUint64(
      4,
      f
    );
  }
  f = message.getCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getUsedCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getPlanCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getUsedPlanCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      8,
      f
    );
  }
};


/**
 * optional uint64 plan_bandwidth = 1;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getPlanBandwidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setPlanBandwidth = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint64 plan_storage = 2;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getPlanStorage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setPlanStorage = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional uint64 used_bandwidth = 3;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getUsedBandwidth = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setUsedBandwidth = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional uint64 used_storage = 4;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getUsedStorage = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setUsedStorage = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional double credit = 5;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double used_credit = 6;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getUsedCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setUsedCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * optional double plan_credit = 7;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getPlanCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setPlanCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional double used_plan_credit = 8;
 * @return {number}
 */
proto.saasphoto.UsageDetail.prototype.getUsedPlanCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 8, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UsageDetail} returns this
 */
proto.saasphoto.UsageDetail.prototype.setUsedPlanCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 8, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.ChangeAccountTypeRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.ChangeAccountTypeRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.ChangeAccountTypeRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.ChangeAccountTypeRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    typeName: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.ChangeAccountTypeRequest}
 */
proto.saasphoto.ChangeAccountTypeRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.ChangeAccountTypeRequest;
  return proto.saasphoto.ChangeAccountTypeRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.ChangeAccountTypeRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.ChangeAccountTypeRequest}
 */
proto.saasphoto.ChangeAccountTypeRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTypeName(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.ChangeAccountTypeRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.ChangeAccountTypeRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.ChangeAccountTypeRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.ChangeAccountTypeRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getTypeName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.ChangeAccountTypeRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.ChangeAccountTypeRequest} returns this
 */
proto.saasphoto.ChangeAccountTypeRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string type_name = 2;
 * @return {string}
 */
proto.saasphoto.ChangeAccountTypeRequest.prototype.getTypeName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.ChangeAccountTypeRequest} returns this
 */
proto.saasphoto.ChangeAccountTypeRequest.prototype.setTypeName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.ChangeUserEmailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.ChangeUserEmailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.ChangeUserEmailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.ChangeUserEmailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    newEmail: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.ChangeUserEmailRequest}
 */
proto.saasphoto.ChangeUserEmailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.ChangeUserEmailRequest;
  return proto.saasphoto.ChangeUserEmailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.ChangeUserEmailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.ChangeUserEmailRequest}
 */
proto.saasphoto.ChangeUserEmailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.ChangeUserEmailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.ChangeUserEmailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.ChangeUserEmailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.ChangeUserEmailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNewEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.ChangeUserEmailRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.ChangeUserEmailRequest} returns this
 */
proto.saasphoto.ChangeUserEmailRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string new_email = 2;
 * @return {string}
 */
proto.saasphoto.ChangeUserEmailRequest.prototype.getNewEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.ChangeUserEmailRequest} returns this
 */
proto.saasphoto.ChangeUserEmailRequest.prototype.setNewEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.ChangeUserPasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.ChangeUserPasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.ChangeUserPasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.ChangeUserPasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    newPassword: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.ChangeUserPasswordRequest}
 */
proto.saasphoto.ChangeUserPasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.ChangeUserPasswordRequest;
  return proto.saasphoto.ChangeUserPasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.ChangeUserPasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.ChangeUserPasswordRequest}
 */
proto.saasphoto.ChangeUserPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setNewPassword(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.ChangeUserPasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.ChangeUserPasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.ChangeUserPasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.ChangeUserPasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getNewPassword();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.ChangeUserPasswordRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.ChangeUserPasswordRequest} returns this
 */
proto.saasphoto.ChangeUserPasswordRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string new_password = 2;
 * @return {string}
 */
proto.saasphoto.ChangeUserPasswordRequest.prototype.getNewPassword = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.ChangeUserPasswordRequest} returns this
 */
proto.saasphoto.ChangeUserPasswordRequest.prototype.setNewPassword = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GenerateUserPasswordRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GenerateUserPasswordRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GenerateUserPasswordRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GenerateUserPasswordRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GenerateUserPasswordRequest}
 */
proto.saasphoto.GenerateUserPasswordRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GenerateUserPasswordRequest;
  return proto.saasphoto.GenerateUserPasswordRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GenerateUserPasswordRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GenerateUserPasswordRequest}
 */
proto.saasphoto.GenerateUserPasswordRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GenerateUserPasswordRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GenerateUserPasswordRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GenerateUserPasswordRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GenerateUserPasswordRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.GenerateUserPasswordRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GenerateUserPasswordRequest} returns this
 */
proto.saasphoto.GenerateUserPasswordRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.UpdateUserStatusRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.UpdateUserStatusRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.UpdateUserStatusRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.UpdateUserStatusRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    status: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.UpdateUserStatusRequest}
 */
proto.saasphoto.UpdateUserStatusRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.UpdateUserStatusRequest;
  return proto.saasphoto.UpdateUserStatusRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.UpdateUserStatusRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.UpdateUserStatusRequest}
 */
proto.saasphoto.UpdateUserStatusRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {!proto.saasphoto.UserStatus} */ (reader.readEnum());
      msg.setStatus(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.UpdateUserStatusRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.UpdateUserStatusRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.UpdateUserStatusRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.UpdateUserStatusRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getStatus();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.UpdateUserStatusRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.UpdateUserStatusRequest} returns this
 */
proto.saasphoto.UpdateUserStatusRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional UserStatus status = 2;
 * @return {!proto.saasphoto.UserStatus}
 */
proto.saasphoto.UpdateUserStatusRequest.prototype.getStatus = function() {
  return /** @type {!proto.saasphoto.UserStatus} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.saasphoto.UserStatus} value
 * @return {!proto.saasphoto.UpdateUserStatusRequest} returns this
 */
proto.saasphoto.UpdateUserStatusRequest.prototype.setStatus = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.AddUserPlanRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.AddUserPlanRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.AddUserPlanRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AddUserPlanRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    planId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    expiryDate: (f = msg.getExpiryDate()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.AddUserPlanRequest}
 */
proto.saasphoto.AddUserPlanRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.AddUserPlanRequest;
  return proto.saasphoto.AddUserPlanRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.AddUserPlanRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.AddUserPlanRequest}
 */
proto.saasphoto.AddUserPlanRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPlanId(value);
      break;
    case 3:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setExpiryDate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.AddUserPlanRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.AddUserPlanRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.AddUserPlanRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AddUserPlanRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getPlanId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getExpiryDate();
  if (f != null) {
    writer.writeMessage(
      3,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.AddUserPlanRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AddUserPlanRequest} returns this
 */
proto.saasphoto.AddUserPlanRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 plan_id = 2;
 * @return {number}
 */
proto.saasphoto.AddUserPlanRequest.prototype.getPlanId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AddUserPlanRequest} returns this
 */
proto.saasphoto.AddUserPlanRequest.prototype.setPlanId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional google.protobuf.Timestamp expiry_date = 3;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.AddUserPlanRequest.prototype.getExpiryDate = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 3));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.AddUserPlanRequest} returns this
*/
proto.saasphoto.AddUserPlanRequest.prototype.setExpiryDate = function(value) {
  return jspb.Message.setWrapperField(this, 3, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.AddUserPlanRequest} returns this
 */
proto.saasphoto.AddUserPlanRequest.prototype.clearExpiryDate = function() {
  return this.setExpiryDate(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.AddUserPlanRequest.prototype.hasExpiryDate = function() {
  return jspb.Message.getField(this, 3) != null;
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.SendSystemNotifyMailRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.SendSystemNotifyMailRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.SendSystemNotifyMailRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SendSystemNotifyMailRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    message: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.SendSystemNotifyMailRequest}
 */
proto.saasphoto.SendSystemNotifyMailRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.SendSystemNotifyMailRequest;
  return proto.saasphoto.SendSystemNotifyMailRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.SendSystemNotifyMailRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.SendSystemNotifyMailRequest}
 */
proto.saasphoto.SendSystemNotifyMailRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setMessage(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.SendSystemNotifyMailRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.SendSystemNotifyMailRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.SendSystemNotifyMailRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.SendSystemNotifyMailRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getMessage();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string message = 1;
 * @return {string}
 */
proto.saasphoto.SendSystemNotifyMailRequest.prototype.getMessage = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.SendSystemNotifyMailRequest} returns this
 */
proto.saasphoto.SendSystemNotifyMailRequest.prototype.setMessage = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetBandwidthUsagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetBandwidthUsagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBandwidthUsagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0),
    unit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetBandwidthUsagesRequest}
 */
proto.saasphoto.GetBandwidthUsagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetBandwidthUsagesRequest;
  return proto.saasphoto.GetBandwidthUsagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetBandwidthUsagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetBandwidthUsagesRequest}
 */
proto.saasphoto.GetBandwidthUsagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    case 3:
      var value = /** @type {!proto.saasphoto.TimeUnit} */ (reader.readEnum());
      msg.setUnit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetBandwidthUsagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetBandwidthUsagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBandwidthUsagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOffset();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 start = 1;
 * @return {number}
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBandwidthUsagesRequest} returns this
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end = 2;
 * @return {number}
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBandwidthUsagesRequest} returns this
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional TimeUnit unit = 3;
 * @return {!proto.saasphoto.TimeUnit}
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.getUnit = function() {
  return /** @type {!proto.saasphoto.TimeUnit} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.saasphoto.TimeUnit} value
 * @return {!proto.saasphoto.GetBandwidthUsagesRequest} returns this
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.setUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string offset = 4;
 * @return {string}
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.getOffset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetBandwidthUsagesRequest} returns this
 */
proto.saasphoto.GetBandwidthUsagesRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetBandwidthUsagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetBandwidthUsagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetBandwidthUsagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetBandwidthUsagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBandwidthUsagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usagesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetBandwidthUsagesResponse}
 */
proto.saasphoto.GetBandwidthUsagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetBandwidthUsagesResponse;
  return proto.saasphoto.GetBandwidthUsagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetBandwidthUsagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetBandwidthUsagesResponse}
 */
proto.saasphoto.GetBandwidthUsagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedInt64() : [reader.readInt64()]);
      for (var i = 0; i < values.length; i++) {
        msg.addUsages(values[i]);
      }
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetBandwidthUsagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetBandwidthUsagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetBandwidthUsagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBandwidthUsagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsagesList();
  if (f.length > 0) {
    writer.writePackedInt64(
      1,
      f
    );
  }
};


/**
 * repeated int64 usages = 1;
 * @return {!Array<number>}
 */
proto.saasphoto.GetBandwidthUsagesResponse.prototype.getUsagesList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.saasphoto.GetBandwidthUsagesResponse} returns this
 */
proto.saasphoto.GetBandwidthUsagesResponse.prototype.setUsagesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.GetBandwidthUsagesResponse} returns this
 */
proto.saasphoto.GetBandwidthUsagesResponse.prototype.addUsages = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBandwidthUsagesResponse} returns this
 */
proto.saasphoto.GetBandwidthUsagesResponse.prototype.clearUsagesList = function() {
  return this.setUsagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.StorageUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.StorageUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.StorageUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.StorageUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    size: jspb.Message.getFieldWithDefault(msg, 3, 0),
    quota: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.StorageUsage}
 */
proto.saasphoto.StorageUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.StorageUsage;
  return proto.saasphoto.StorageUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.StorageUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.StorageUsage}
 */
proto.saasphoto.StorageUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setQuota(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.StorageUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.StorageUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.StorageUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.StorageUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getQuota();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.StorageUsage.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.StorageUsage} returns this
 */
proto.saasphoto.StorageUsage.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.saasphoto.StorageUsage.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.StorageUsage} returns this
 */
proto.saasphoto.StorageUsage.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 size = 3;
 * @return {number}
 */
proto.saasphoto.StorageUsage.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.StorageUsage} returns this
 */
proto.saasphoto.StorageUsage.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 quota = 4;
 * @return {number}
 */
proto.saasphoto.StorageUsage.prototype.getQuota = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.StorageUsage} returns this
 */
proto.saasphoto.StorageUsage.prototype.setQuota = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetStorageUsagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetStorageUsagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetStorageUsagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetStorageUsagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetStorageUsagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usagesList: jspb.Message.toObjectList(msg.getUsagesList(),
    proto.saasphoto.StorageUsage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetStorageUsagesResponse}
 */
proto.saasphoto.GetStorageUsagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetStorageUsagesResponse;
  return proto.saasphoto.GetStorageUsagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetStorageUsagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetStorageUsagesResponse}
 */
proto.saasphoto.GetStorageUsagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.StorageUsage;
      reader.readMessage(value,proto.saasphoto.StorageUsage.deserializeBinaryFromReader);
      msg.addUsages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetStorageUsagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetStorageUsagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetStorageUsagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetStorageUsagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.StorageUsage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated StorageUsage usages = 1;
 * @return {!Array<!proto.saasphoto.StorageUsage>}
 */
proto.saasphoto.GetStorageUsagesResponse.prototype.getUsagesList = function() {
  return /** @type{!Array<!proto.saasphoto.StorageUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.StorageUsage, 1));
};


/**
 * @param {!Array<!proto.saasphoto.StorageUsage>} value
 * @return {!proto.saasphoto.GetStorageUsagesResponse} returns this
*/
proto.saasphoto.GetStorageUsagesResponse.prototype.setUsagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.StorageUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.StorageUsage}
 */
proto.saasphoto.GetStorageUsagesResponse.prototype.addUsages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.StorageUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetStorageUsagesResponse} returns this
 */
proto.saasphoto.GetStorageUsagesResponse.prototype.clearUsagesList = function() {
  return this.setUsagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetUserBandwidthUsagesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetUserBandwidthUsagesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetUserBandwidthUsagesRequest}
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetUserBandwidthUsagesRequest;
  return proto.saasphoto.GetUserBandwidthUsagesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetUserBandwidthUsagesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetUserBandwidthUsagesRequest}
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetUserBandwidthUsagesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetUserBandwidthUsagesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 start = 1;
 * @return {number}
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetUserBandwidthUsagesRequest} returns this
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end = 2;
 * @return {number}
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetUserBandwidthUsagesRequest} returns this
 */
proto.saasphoto.GetUserBandwidthUsagesRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.BandwidthUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.BandwidthUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.BandwidthUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.BandwidthUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, ""),
    size: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.BandwidthUsage}
 */
proto.saasphoto.BandwidthUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.BandwidthUsage;
  return proto.saasphoto.BandwidthUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.BandwidthUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.BandwidthUsage}
 */
proto.saasphoto.BandwidthUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSize(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.BandwidthUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.BandwidthUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.BandwidthUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.BandwidthUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getSize();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.saasphoto.BandwidthUsage.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.BandwidthUsage} returns this
 */
proto.saasphoto.BandwidthUsage.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 size = 2;
 * @return {number}
 */
proto.saasphoto.BandwidthUsage.prototype.getSize = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.BandwidthUsage} returns this
 */
proto.saasphoto.BandwidthUsage.prototype.setSize = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetUserBandwidthUsagesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetUserBandwidthUsagesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    usagesList: jspb.Message.toObjectList(msg.getUsagesList(),
    proto.saasphoto.BandwidthUsage.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetUserBandwidthUsagesResponse}
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetUserBandwidthUsagesResponse;
  return proto.saasphoto.GetUserBandwidthUsagesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetUserBandwidthUsagesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetUserBandwidthUsagesResponse}
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.saasphoto.BandwidthUsage;
      reader.readMessage(value,proto.saasphoto.BandwidthUsage.deserializeBinaryFromReader);
      msg.addUsages(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetUserBandwidthUsagesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetUserBandwidthUsagesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUsagesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.saasphoto.BandwidthUsage.serializeBinaryToWriter
    );
  }
};


/**
 * repeated BandwidthUsage usages = 1;
 * @return {!Array<!proto.saasphoto.BandwidthUsage>}
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.prototype.getUsagesList = function() {
  return /** @type{!Array<!proto.saasphoto.BandwidthUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.BandwidthUsage, 1));
};


/**
 * @param {!Array<!proto.saasphoto.BandwidthUsage>} value
 * @return {!proto.saasphoto.GetUserBandwidthUsagesResponse} returns this
*/
proto.saasphoto.GetUserBandwidthUsagesResponse.prototype.setUsagesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.saasphoto.BandwidthUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.BandwidthUsage}
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.prototype.addUsages = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.saasphoto.BandwidthUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetUserBandwidthUsagesResponse} returns this
 */
proto.saasphoto.GetUserBandwidthUsagesResponse.prototype.clearUsagesList = function() {
  return this.setUsagesList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetSubscriptionStatusResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetSubscriptionStatusResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetSubscriptionStatusResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    subscription: jspb.Message.getFieldWithDefault(msg, 1, 0),
    subscriptionExpired: jspb.Message.getFieldWithDefault(msg, 2, 0),
    freeTrial: jspb.Message.getFieldWithDefault(msg, 3, 0),
    freeTrialExpired: jspb.Message.getFieldWithDefault(msg, 4, 0),
    other: jspb.Message.getFieldWithDefault(msg, 5, 0),
    hostingActive: jspb.Message.getFieldWithDefault(msg, 6, 0),
    hostingExpired: jspb.Message.getFieldWithDefault(msg, 7, 0),
    hostingTrialActive: jspb.Message.getFieldWithDefault(msg, 8, 0),
    hostingTrialExpired: jspb.Message.getFieldWithDefault(msg, 9, 0),
    aiActive: jspb.Message.getFieldWithDefault(msg, 10, 0),
    aiExpired: jspb.Message.getFieldWithDefault(msg, 11, 0),
    aiTrialActive: jspb.Message.getFieldWithDefault(msg, 12, 0),
    aiTrialExpired: jspb.Message.getFieldWithDefault(msg, 13, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse}
 */
proto.saasphoto.GetSubscriptionStatusResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetSubscriptionStatusResponse;
  return proto.saasphoto.GetSubscriptionStatusResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetSubscriptionStatusResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse}
 */
proto.saasphoto.GetSubscriptionStatusResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscription(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setSubscriptionExpired(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFreeTrial(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setFreeTrialExpired(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setOther(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHostingActive(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHostingExpired(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHostingTrialActive(value);
      break;
    case 9:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setHostingTrialExpired(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiActive(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiExpired(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiTrialActive(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt32());
      msg.setAiTrialExpired(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetSubscriptionStatusResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetSubscriptionStatusResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetSubscriptionStatusResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getSubscription();
  if (f !== 0) {
    writer.writeInt32(
      1,
      f
    );
  }
  f = message.getSubscriptionExpired();
  if (f !== 0) {
    writer.writeInt32(
      2,
      f
    );
  }
  f = message.getFreeTrial();
  if (f !== 0) {
    writer.writeInt32(
      3,
      f
    );
  }
  f = message.getFreeTrialExpired();
  if (f !== 0) {
    writer.writeInt32(
      4,
      f
    );
  }
  f = message.getOther();
  if (f !== 0) {
    writer.writeInt32(
      5,
      f
    );
  }
  f = message.getHostingActive();
  if (f !== 0) {
    writer.writeInt32(
      6,
      f
    );
  }
  f = message.getHostingExpired();
  if (f !== 0) {
    writer.writeInt32(
      7,
      f
    );
  }
  f = message.getHostingTrialActive();
  if (f !== 0) {
    writer.writeInt32(
      8,
      f
    );
  }
  f = message.getHostingTrialExpired();
  if (f !== 0) {
    writer.writeInt32(
      9,
      f
    );
  }
  f = message.getAiActive();
  if (f !== 0) {
    writer.writeInt32(
      10,
      f
    );
  }
  f = message.getAiExpired();
  if (f !== 0) {
    writer.writeInt32(
      11,
      f
    );
  }
  f = message.getAiTrialActive();
  if (f !== 0) {
    writer.writeInt32(
      12,
      f
    );
  }
  f = message.getAiTrialExpired();
  if (f !== 0) {
    writer.writeInt32(
      13,
      f
    );
  }
};


/**
 * optional int32 subscription = 1;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getSubscription = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setSubscription = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int32 subscription_expired = 2;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getSubscriptionExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setSubscriptionExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int32 free_trial = 3;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getFreeTrial = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setFreeTrial = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int32 free_trial_expired = 4;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getFreeTrialExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setFreeTrialExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int32 other = 5;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getOther = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setOther = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional int32 hosting_active = 6;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getHostingActive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setHostingActive = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int32 hosting_expired = 7;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getHostingExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setHostingExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};


/**
 * optional int32 hosting_trial_active = 8;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getHostingTrialActive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setHostingTrialActive = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional int32 hosting_trial_expired = 9;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getHostingTrialExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 9, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setHostingTrialExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 9, value);
};


/**
 * optional int32 ai_active = 10;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getAiActive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setAiActive = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int32 ai_expired = 11;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getAiExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setAiExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int32 ai_trial_active = 12;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getAiTrialActive = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setAiTrialActive = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int32 ai_trial_expired = 13;
 * @return {number}
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.getAiTrialExpired = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetSubscriptionStatusResponse} returns this
 */
proto.saasphoto.GetSubscriptionStatusResponse.prototype.setAiTrialExpired = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetPaymentStatisticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetPaymentStatisticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPaymentStatisticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0),
    unit: jspb.Message.getFieldWithDefault(msg, 3, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetPaymentStatisticsRequest}
 */
proto.saasphoto.GetPaymentStatisticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetPaymentStatisticsRequest;
  return proto.saasphoto.GetPaymentStatisticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetPaymentStatisticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetPaymentStatisticsRequest}
 */
proto.saasphoto.GetPaymentStatisticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    case 3:
      var value = /** @type {!proto.saasphoto.TimeUnit} */ (reader.readEnum());
      msg.setUnit(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setOffset(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetPaymentStatisticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetPaymentStatisticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPaymentStatisticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getUnit();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getOffset();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 start = 1;
 * @return {number}
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetPaymentStatisticsRequest} returns this
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end = 2;
 * @return {number}
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetPaymentStatisticsRequest} returns this
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional TimeUnit unit = 3;
 * @return {!proto.saasphoto.TimeUnit}
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.getUnit = function() {
  return /** @type {!proto.saasphoto.TimeUnit} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.saasphoto.TimeUnit} value
 * @return {!proto.saasphoto.GetPaymentStatisticsRequest} returns this
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.setUnit = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional string offset = 4;
 * @return {string}
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.getOffset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetPaymentStatisticsRequest} returns this
 */
proto.saasphoto.GetPaymentStatisticsRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.RevenuePayment.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.RevenuePayment.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.RevenuePayment} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.RevenuePayment.toObject = function(includeInstance, msg) {
  var f, obj = {
    transactionId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    userId: jspb.Message.getFieldWithDefault(msg, 2, 0),
    userName: jspb.Message.getFieldWithDefault(msg, 3, ""),
    email: jspb.Message.getFieldWithDefault(msg, 4, ""),
    source: jspb.Message.getFieldWithDefault(msg, 5, ""),
    planName: jspb.Message.getFieldWithDefault(msg, 6, ""),
    amount: jspb.Message.getFloatingPointFieldWithDefault(msg, 7, 0.0),
    billingPeriod: jspb.Message.getFieldWithDefault(msg, 8, 0),
    paidAt: (f = msg.getPaidAt()) && google_protobuf_timestamp_pb.Timestamp.toObject(includeInstance, f),
    planMonths: jspb.Message.getFieldWithDefault(msg, 10, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.RevenuePayment}
 */
proto.saasphoto.RevenuePayment.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.RevenuePayment;
  return proto.saasphoto.RevenuePayment.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.RevenuePayment} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.RevenuePayment}
 */
proto.saasphoto.RevenuePayment.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setTransactionId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setUserName(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setSource(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlanName(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAmount(value);
      break;
    case 8:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setBillingPeriod(value);
      break;
    case 9:
      var value = new google_protobuf_timestamp_pb.Timestamp;
      reader.readMessage(value,google_protobuf_timestamp_pb.Timestamp.deserializeBinaryFromReader);
      msg.setPaidAt(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setPlanMonths(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.RevenuePayment.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.RevenuePayment.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.RevenuePayment} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.RevenuePayment.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTransactionId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      2,
      f
    );
  }
  f = message.getUserName();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getSource();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getPlanName();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getAmount();
  if (f !== 0.0) {
    writer.writeDouble(
      7,
      f
    );
  }
  f = message.getBillingPeriod();
  if (f !== 0) {
    writer.writeUint32(
      8,
      f
    );
  }
  f = message.getPaidAt();
  if (f != null) {
    writer.writeMessage(
      9,
      f,
      google_protobuf_timestamp_pb.Timestamp.serializeBinaryToWriter
    );
  }
  f = message.getPlanMonths();
  if (f !== 0) {
    writer.writeUint32(
      10,
      f
    );
  }
};


/**
 * optional uint32 transaction_id = 1;
 * @return {number}
 */
proto.saasphoto.RevenuePayment.prototype.getTransactionId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setTransactionId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional uint32 user_id = 2;
 * @return {number}
 */
proto.saasphoto.RevenuePayment.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string user_name = 3;
 * @return {string}
 */
proto.saasphoto.RevenuePayment.prototype.getUserName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setUserName = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string email = 4;
 * @return {string}
 */
proto.saasphoto.RevenuePayment.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string source = 5;
 * @return {string}
 */
proto.saasphoto.RevenuePayment.prototype.getSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setSource = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional string plan_name = 6;
 * @return {string}
 */
proto.saasphoto.RevenuePayment.prototype.getPlanName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setPlanName = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional double amount = 7;
 * @return {number}
 */
proto.saasphoto.RevenuePayment.prototype.getAmount = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 7, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setAmount = function(value) {
  return jspb.Message.setProto3FloatField(this, 7, value);
};


/**
 * optional uint32 billing_period = 8;
 * @return {number}
 */
proto.saasphoto.RevenuePayment.prototype.getBillingPeriod = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 8, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setBillingPeriod = function(value) {
  return jspb.Message.setProto3IntField(this, 8, value);
};


/**
 * optional google.protobuf.Timestamp paid_at = 9;
 * @return {?proto.google.protobuf.Timestamp}
 */
proto.saasphoto.RevenuePayment.prototype.getPaidAt = function() {
  return /** @type{?proto.google.protobuf.Timestamp} */ (
    jspb.Message.getWrapperField(this, google_protobuf_timestamp_pb.Timestamp, 9));
};


/**
 * @param {?proto.google.protobuf.Timestamp|undefined} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
*/
proto.saasphoto.RevenuePayment.prototype.setPaidAt = function(value) {
  return jspb.Message.setWrapperField(this, 9, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.clearPaidAt = function() {
  return this.setPaidAt(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.saasphoto.RevenuePayment.prototype.hasPaidAt = function() {
  return jspb.Message.getField(this, 9) != null;
};


/**
 * optional uint32 plan_months = 10;
 * @return {number}
 */
proto.saasphoto.RevenuePayment.prototype.getPlanMonths = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.RevenuePayment} returns this
 */
proto.saasphoto.RevenuePayment.prototype.setPlanMonths = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetPaymentStatisticsResponse.repeatedFields_ = [1,2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetPaymentStatisticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetPaymentStatisticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPaymentStatisticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    amountsList: (f = jspb.Message.getRepeatedFloatingPointField(msg, 1)) == null ? undefined : f,
    paymentsList: jspb.Message.toObjectList(msg.getPaymentsList(),
    proto.saasphoto.RevenuePayment.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetPaymentStatisticsResponse}
 */
proto.saasphoto.GetPaymentStatisticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetPaymentStatisticsResponse;
  return proto.saasphoto.GetPaymentStatisticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetPaymentStatisticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetPaymentStatisticsResponse}
 */
proto.saasphoto.GetPaymentStatisticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var values = /** @type {!Array<number>} */ (reader.isDelimited() ? reader.readPackedFloat() : [reader.readFloat()]);
      for (var i = 0; i < values.length; i++) {
        msg.addAmounts(values[i]);
      }
      break;
    case 2:
      var value = new proto.saasphoto.RevenuePayment;
      reader.readMessage(value,proto.saasphoto.RevenuePayment.deserializeBinaryFromReader);
      msg.addPayments(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetPaymentStatisticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetPaymentStatisticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetPaymentStatisticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAmountsList();
  if (f.length > 0) {
    writer.writePackedFloat(
      1,
      f
    );
  }
  f = message.getPaymentsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.saasphoto.RevenuePayment.serializeBinaryToWriter
    );
  }
};


/**
 * repeated float amounts = 1;
 * @return {!Array<number>}
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.getAmountsList = function() {
  return /** @type {!Array<number>} */ (jspb.Message.getRepeatedFloatingPointField(this, 1));
};


/**
 * @param {!Array<number>} value
 * @return {!proto.saasphoto.GetPaymentStatisticsResponse} returns this
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.setAmountsList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {number} value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.GetPaymentStatisticsResponse} returns this
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.addAmounts = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetPaymentStatisticsResponse} returns this
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.clearAmountsList = function() {
  return this.setAmountsList([]);
};


/**
 * repeated RevenuePayment payments = 2;
 * @return {!Array<!proto.saasphoto.RevenuePayment>}
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.getPaymentsList = function() {
  return /** @type{!Array<!proto.saasphoto.RevenuePayment>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.RevenuePayment, 2));
};


/**
 * @param {!Array<!proto.saasphoto.RevenuePayment>} value
 * @return {!proto.saasphoto.GetPaymentStatisticsResponse} returns this
*/
proto.saasphoto.GetPaymentStatisticsResponse.prototype.setPaymentsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.saasphoto.RevenuePayment=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.RevenuePayment}
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.addPayments = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.saasphoto.RevenuePayment, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetPaymentStatisticsResponse} returns this
 */
proto.saasphoto.GetPaymentStatisticsResponse.prototype.clearPaymentsList = function() {
  return this.setPaymentsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetCreditStatisticsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetCreditStatisticsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetCreditStatisticsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetCreditStatisticsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetCreditStatisticsRequest}
 */
proto.saasphoto.GetCreditStatisticsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetCreditStatisticsRequest;
  return proto.saasphoto.GetCreditStatisticsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetCreditStatisticsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetCreditStatisticsRequest}
 */
proto.saasphoto.GetCreditStatisticsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetCreditStatisticsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetCreditStatisticsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetCreditStatisticsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetCreditStatisticsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
};


/**
 * optional int64 start = 1;
 * @return {number}
 */
proto.saasphoto.GetCreditStatisticsRequest.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetCreditStatisticsRequest} returns this
 */
proto.saasphoto.GetCreditStatisticsRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end = 2;
 * @return {number}
 */
proto.saasphoto.GetCreditStatisticsRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetCreditStatisticsRequest} returns this
 */
proto.saasphoto.GetCreditStatisticsRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.CreditUsageSource.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.CreditUsageSource.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.CreditUsageSource} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreditUsageSource.toObject = function(includeInstance, msg) {
  var f, obj = {
    triggerSource: jspb.Message.getFieldWithDefault(msg, 1, ""),
    total: jspb.Message.getFieldWithDefault(msg, 2, 0),
    succeeded: jspb.Message.getFieldWithDefault(msg, 3, 0),
    failed: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.CreditUsageSource}
 */
proto.saasphoto.CreditUsageSource.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.CreditUsageSource;
  return proto.saasphoto.CreditUsageSource.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.CreditUsageSource} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.CreditUsageSource}
 */
proto.saasphoto.CreditUsageSource.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setTriggerSource(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSucceeded(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFailed(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.CreditUsageSource.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.CreditUsageSource.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.CreditUsageSource} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreditUsageSource.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTriggerSource();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getSucceeded();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getFailed();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string trigger_source = 1;
 * @return {string}
 */
proto.saasphoto.CreditUsageSource.prototype.getTriggerSource = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreditUsageSource} returns this
 */
proto.saasphoto.CreditUsageSource.prototype.setTriggerSource = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional int64 total = 2;
 * @return {number}
 */
proto.saasphoto.CreditUsageSource.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreditUsageSource} returns this
 */
proto.saasphoto.CreditUsageSource.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 succeeded = 3;
 * @return {number}
 */
proto.saasphoto.CreditUsageSource.prototype.getSucceeded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreditUsageSource} returns this
 */
proto.saasphoto.CreditUsageSource.prototype.setSucceeded = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 failed = 4;
 * @return {number}
 */
proto.saasphoto.CreditUsageSource.prototype.getFailed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreditUsageSource} returns this
 */
proto.saasphoto.CreditUsageSource.prototype.setFailed = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.CreditUserUsage.repeatedFields_ = [6];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.CreditUserUsage.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.CreditUserUsage.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.CreditUserUsage} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreditUserUsage.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    total: jspb.Message.getFieldWithDefault(msg, 3, 0),
    succeeded: jspb.Message.getFieldWithDefault(msg, 4, 0),
    failed: jspb.Message.getFieldWithDefault(msg, 5, 0),
    sourcesList: jspb.Message.toObjectList(msg.getSourcesList(),
    proto.saasphoto.CreditUsageSource.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.CreditUserUsage}
 */
proto.saasphoto.CreditUserUsage.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.CreditUserUsage;
  return proto.saasphoto.CreditUserUsage.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.CreditUserUsage} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.CreditUserUsage}
 */
proto.saasphoto.CreditUserUsage.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSucceeded(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFailed(value);
      break;
    case 6:
      var value = new proto.saasphoto.CreditUsageSource;
      reader.readMessage(value,proto.saasphoto.CreditUsageSource.deserializeBinaryFromReader);
      msg.addSources(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.CreditUserUsage.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.CreditUserUsage.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.CreditUserUsage} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.CreditUserUsage.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSucceeded();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getFailed();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getSourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      6,
      f,
      proto.saasphoto.CreditUsageSource.serializeBinaryToWriter
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.CreditUserUsage.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreditUserUsage} returns this
 */
proto.saasphoto.CreditUserUsage.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.saasphoto.CreditUserUsage.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.CreditUserUsage} returns this
 */
proto.saasphoto.CreditUserUsage.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional int64 total = 3;
 * @return {number}
 */
proto.saasphoto.CreditUserUsage.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreditUserUsage} returns this
 */
proto.saasphoto.CreditUserUsage.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * optional int64 succeeded = 4;
 * @return {number}
 */
proto.saasphoto.CreditUserUsage.prototype.getSucceeded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreditUserUsage} returns this
 */
proto.saasphoto.CreditUserUsage.prototype.setSucceeded = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 failed = 5;
 * @return {number}
 */
proto.saasphoto.CreditUserUsage.prototype.getFailed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.CreditUserUsage} returns this
 */
proto.saasphoto.CreditUserUsage.prototype.setFailed = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * repeated CreditUsageSource sources = 6;
 * @return {!Array<!proto.saasphoto.CreditUsageSource>}
 */
proto.saasphoto.CreditUserUsage.prototype.getSourcesList = function() {
  return /** @type{!Array<!proto.saasphoto.CreditUsageSource>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.CreditUsageSource, 6));
};


/**
 * @param {!Array<!proto.saasphoto.CreditUsageSource>} value
 * @return {!proto.saasphoto.CreditUserUsage} returns this
*/
proto.saasphoto.CreditUserUsage.prototype.setSourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 6, value);
};


/**
 * @param {!proto.saasphoto.CreditUsageSource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.CreditUsageSource}
 */
proto.saasphoto.CreditUserUsage.prototype.addSources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 6, opt_value, proto.saasphoto.CreditUsageSource, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.CreditUserUsage} returns this
 */
proto.saasphoto.CreditUserUsage.prototype.clearSourcesList = function() {
  return this.setSourcesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetCreditStatisticsResponse.repeatedFields_ = [4,5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetCreditStatisticsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetCreditStatisticsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetCreditStatisticsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    total: jspb.Message.getFieldWithDefault(msg, 1, 0),
    succeeded: jspb.Message.getFieldWithDefault(msg, 2, 0),
    failed: jspb.Message.getFieldWithDefault(msg, 3, 0),
    sourcesList: jspb.Message.toObjectList(msg.getSourcesList(),
    proto.saasphoto.CreditUsageSource.toObject, includeInstance),
    usersList: jspb.Message.toObjectList(msg.getUsersList(),
    proto.saasphoto.CreditUserUsage.toObject, includeInstance),
    planFunded: jspb.Message.getFieldWithDefault(msg, 6, 0),
    refillFunded: jspb.Message.getFieldWithDefault(msg, 7, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetCreditStatisticsResponse}
 */
proto.saasphoto.GetCreditStatisticsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetCreditStatisticsResponse;
  return proto.saasphoto.GetCreditStatisticsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetCreditStatisticsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetCreditStatisticsResponse}
 */
proto.saasphoto.GetCreditStatisticsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotal(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSucceeded(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFailed(value);
      break;
    case 4:
      var value = new proto.saasphoto.CreditUsageSource;
      reader.readMessage(value,proto.saasphoto.CreditUsageSource.deserializeBinaryFromReader);
      msg.addSources(value);
      break;
    case 5:
      var value = new proto.saasphoto.CreditUserUsage;
      reader.readMessage(value,proto.saasphoto.CreditUserUsage.deserializeBinaryFromReader);
      msg.addUsers(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPlanFunded(value);
      break;
    case 7:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRefillFunded(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetCreditStatisticsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetCreditStatisticsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetCreditStatisticsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTotal();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getSucceeded();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getFailed();
  if (f !== 0) {
    writer.writeInt64(
      3,
      f
    );
  }
  f = message.getSourcesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.saasphoto.CreditUsageSource.serializeBinaryToWriter
    );
  }
  f = message.getUsersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      5,
      f,
      proto.saasphoto.CreditUserUsage.serializeBinaryToWriter
    );
  }
  f = message.getPlanFunded();
  if (f !== 0) {
    writer.writeInt64(
      6,
      f
    );
  }
  f = message.getRefillFunded();
  if (f !== 0) {
    writer.writeInt64(
      7,
      f
    );
  }
};


/**
 * optional int64 total = 1;
 * @return {number}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.getTotal = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.setTotal = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 succeeded = 2;
 * @return {number}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.getSucceeded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.setSucceeded = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional int64 failed = 3;
 * @return {number}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.getFailed = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.setFailed = function(value) {
  return jspb.Message.setProto3IntField(this, 3, value);
};


/**
 * repeated CreditUsageSource sources = 4;
 * @return {!Array<!proto.saasphoto.CreditUsageSource>}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.getSourcesList = function() {
  return /** @type{!Array<!proto.saasphoto.CreditUsageSource>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.CreditUsageSource, 4));
};


/**
 * @param {!Array<!proto.saasphoto.CreditUsageSource>} value
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
*/
proto.saasphoto.GetCreditStatisticsResponse.prototype.setSourcesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.saasphoto.CreditUsageSource=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.CreditUsageSource}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.addSources = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.saasphoto.CreditUsageSource, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.clearSourcesList = function() {
  return this.setSourcesList([]);
};


/**
 * repeated CreditUserUsage users = 5;
 * @return {!Array<!proto.saasphoto.CreditUserUsage>}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.getUsersList = function() {
  return /** @type{!Array<!proto.saasphoto.CreditUserUsage>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.CreditUserUsage, 5));
};


/**
 * @param {!Array<!proto.saasphoto.CreditUserUsage>} value
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
*/
proto.saasphoto.GetCreditStatisticsResponse.prototype.setUsersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 5, value);
};


/**
 * @param {!proto.saasphoto.CreditUserUsage=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.CreditUserUsage}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.addUsers = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 5, opt_value, proto.saasphoto.CreditUserUsage, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.clearUsersList = function() {
  return this.setUsersList([]);
};


/**
 * optional int64 plan_funded = 6;
 * @return {number}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.getPlanFunded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 6, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.setPlanFunded = function(value) {
  return jspb.Message.setProto3IntField(this, 6, value);
};


/**
 * optional int64 refill_funded = 7;
 * @return {number}
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.getRefillFunded = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 7, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetCreditStatisticsResponse} returns this
 */
proto.saasphoto.GetCreditStatisticsResponse.prototype.setRefillFunded = function(value) {
  return jspb.Message.setProto3IntField(this, 7, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.AnalyticsBreakdown.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.AnalyticsBreakdown.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.AnalyticsBreakdown} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AnalyticsBreakdown.toObject = function(includeInstance, msg) {
  var f, obj = {
    key: jspb.Message.getFieldWithDefault(msg, 1, ""),
    label: jspb.Message.getFieldWithDefault(msg, 2, ""),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    count: jspb.Message.getFieldWithDefault(msg, 4, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.AnalyticsBreakdown.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.AnalyticsBreakdown;
  return proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.AnalyticsBreakdown} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setKey(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setLabel(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCount(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.AnalyticsBreakdown.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.AnalyticsBreakdown} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getKey();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getLabel();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getCount();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
};


/**
 * optional string key = 1;
 * @return {string}
 */
proto.saasphoto.AnalyticsBreakdown.prototype.getKey = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.AnalyticsBreakdown} returns this
 */
proto.saasphoto.AnalyticsBreakdown.prototype.setKey = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string label = 2;
 * @return {string}
 */
proto.saasphoto.AnalyticsBreakdown.prototype.getLabel = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.AnalyticsBreakdown} returns this
 */
proto.saasphoto.AnalyticsBreakdown.prototype.setLabel = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional double value = 3;
 * @return {number}
 */
proto.saasphoto.AnalyticsBreakdown.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsBreakdown} returns this
 */
proto.saasphoto.AnalyticsBreakdown.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int64 count = 4;
 * @return {number}
 */
proto.saasphoto.AnalyticsBreakdown.prototype.getCount = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsBreakdown} returns this
 */
proto.saasphoto.AnalyticsBreakdown.prototype.setCount = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.AnalyticsTrendPoint.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.AnalyticsTrendPoint} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AnalyticsTrendPoint.toObject = function(includeInstance, msg) {
  var f, obj = {
    timestamp: jspb.Message.getFieldWithDefault(msg, 1, 0),
    value: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    secondary: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    tertiary: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.AnalyticsTrendPoint}
 */
proto.saasphoto.AnalyticsTrendPoint.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.AnalyticsTrendPoint;
  return proto.saasphoto.AnalyticsTrendPoint.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.AnalyticsTrendPoint} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.AnalyticsTrendPoint}
 */
proto.saasphoto.AnalyticsTrendPoint.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTimestamp(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setValue(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setSecondary(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setTertiary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.AnalyticsTrendPoint.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.AnalyticsTrendPoint} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AnalyticsTrendPoint.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getTimestamp();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getValue();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getSecondary();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getTertiary();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
};


/**
 * optional int64 timestamp = 1;
 * @return {number}
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.getTimestamp = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsTrendPoint} returns this
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.setTimestamp = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double value = 2;
 * @return {number}
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.getValue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsTrendPoint} returns this
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.setValue = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double secondary = 3;
 * @return {number}
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.getSecondary = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsTrendPoint} returns this
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.setSecondary = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional double tertiary = 4;
 * @return {number}
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.getTertiary = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsTrendPoint} returns this
 */
proto.saasphoto.AnalyticsTrendPoint.prototype.setTertiary = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.AnalyticsRiskAccount.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.AnalyticsRiskAccount} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AnalyticsRiskAccount.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    email: jspb.Message.getFieldWithDefault(msg, 2, ""),
    risk: jspb.Message.getFieldWithDefault(msg, 3, ""),
    used: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
    quota: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
    ratio: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.AnalyticsRiskAccount}
 */
proto.saasphoto.AnalyticsRiskAccount.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.AnalyticsRiskAccount;
  return proto.saasphoto.AnalyticsRiskAccount.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.AnalyticsRiskAccount} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.AnalyticsRiskAccount}
 */
proto.saasphoto.AnalyticsRiskAccount.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setRisk(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setUsed(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setQuota(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRatio(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.AnalyticsRiskAccount.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.AnalyticsRiskAccount} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AnalyticsRiskAccount.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getRisk();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getUsed();
  if (f !== 0.0) {
    writer.writeDouble(
      4,
      f
    );
  }
  f = message.getQuota();
  if (f !== 0.0) {
    writer.writeDouble(
      5,
      f
    );
  }
  f = message.getRatio();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsRiskAccount} returns this
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional string email = 2;
 * @return {string}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.AnalyticsRiskAccount} returns this
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string risk = 3;
 * @return {string}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.getRisk = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.AnalyticsRiskAccount} returns this
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.setRisk = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional double used = 4;
 * @return {number}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.getUsed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsRiskAccount} returns this
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.setUsed = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional double quota = 5;
 * @return {number}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.getQuota = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsRiskAccount} returns this
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.setQuota = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional double ratio = 6;
 * @return {number}
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.getRatio = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AnalyticsRiskAccount} returns this
 */
proto.saasphoto.AnalyticsRiskAccount.prototype.setRatio = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetBusinessInsightsRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetBusinessInsightsRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBusinessInsightsRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    start: jspb.Message.getFieldWithDefault(msg, 1, 0),
    end: jspb.Message.getFieldWithDefault(msg, 2, 0),
    offset: jspb.Message.getFieldWithDefault(msg, 3, ""),
    fileExtension: jspb.Message.getFieldWithDefault(msg, 4, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetBusinessInsightsRequest}
 */
proto.saasphoto.GetBusinessInsightsRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetBusinessInsightsRequest;
  return proto.saasphoto.GetBusinessInsightsRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetBusinessInsightsRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetBusinessInsightsRequest}
 */
proto.saasphoto.GetBusinessInsightsRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStart(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEnd(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOffset(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setFileExtension(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetBusinessInsightsRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetBusinessInsightsRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBusinessInsightsRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getStart();
  if (f !== 0) {
    writer.writeInt64(
      1,
      f
    );
  }
  f = message.getEnd();
  if (f !== 0) {
    writer.writeInt64(
      2,
      f
    );
  }
  f = message.getOffset();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getFileExtension();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
};


/**
 * optional int64 start = 1;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.getStart = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsRequest} returns this
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.setStart = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional int64 end = 2;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.getEnd = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsRequest} returns this
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.setEnd = function(value) {
  return jspb.Message.setProto3IntField(this, 2, value);
};


/**
 * optional string offset = 3;
 * @return {string}
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.getOffset = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetBusinessInsightsRequest} returns this
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.setOffset = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string file_extension = 4;
 * @return {string}
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.getFileExtension = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.GetBusinessInsightsRequest} returns this
 */
proto.saasphoto.GetBusinessInsightsRequest.prototype.setFileExtension = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.saasphoto.GetBusinessInsightsResponse.repeatedFields_ = [7,8,9,28,38,39,43,48,52,53];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.GetBusinessInsightsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.GetBusinessInsightsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBusinessInsightsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    grossRevenue: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
    refunds: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
    netRevenue: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
    successfulPayments: jspb.Message.getFieldWithDefault(msg, 4, 0),
    payingUsers: jspb.Message.getFieldWithDefault(msg, 5, 0),
    averageRevenuePerUser: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0),
    revenueCategoriesList: jspb.Message.toObjectList(msg.getRevenueCategoriesList(),
    proto.saasphoto.AnalyticsBreakdown.toObject, includeInstance),
    revenueCountriesList: jspb.Message.toObjectList(msg.getRevenueCountriesList(),
    proto.saasphoto.AnalyticsBreakdown.toObject, includeInstance),
    revenuePlansList: jspb.Message.toObjectList(msg.getRevenuePlansList(),
    proto.saasphoto.AnalyticsBreakdown.toObject, includeInstance),
    registrations: jspb.Message.getFieldWithDefault(msg, 10, 0),
    trialsStarted: jspb.Message.getFieldWithDefault(msg, 11, 0),
    paidStarted: jspb.Message.getFieldWithDefault(msg, 12, 0),
    cancellations: jspb.Message.getFieldWithDefault(msg, 13, 0),
    trialConversions: jspb.Message.getFieldWithDefault(msg, 14, 0),
    eligibleTrials: jspb.Message.getFieldWithDefault(msg, 15, 0),
    expiring7Days: jspb.Message.getFieldWithDefault(msg, 16, 0),
    expiring30Days: jspb.Message.getFieldWithDefault(msg, 17, 0),
    activeHostingPlans: jspb.Message.getFieldWithDefault(msg, 18, 0),
    activeAiPlans: jspb.Message.getFieldWithDefault(msg, 19, 0),
    dailyActiveUsers: jspb.Message.getFieldWithDefault(msg, 20, 0),
    weeklyActiveUsers: jspb.Message.getFieldWithDefault(msg, 21, 0),
    monthlyActiveUsers: jspb.Message.getFieldWithDefault(msg, 22, 0),
    activeUsers: jspb.Message.getFieldWithDefault(msg, 23, 0),
    retention7Users: jspb.Message.getFieldWithDefault(msg, 24, 0),
    retention7Eligible: jspb.Message.getFieldWithDefault(msg, 25, 0),
    retention30Users: jspb.Message.getFieldWithDefault(msg, 26, 0),
    retention30Eligible: jspb.Message.getFieldWithDefault(msg, 27, 0),
    activeUserTrendList: jspb.Message.toObjectList(msg.getActiveUserTrendList(),
    proto.saasphoto.AnalyticsTrendPoint.toObject, includeInstance),
    processingTasks: jspb.Message.getFieldWithDefault(msg, 29, 0),
    completedTasks: jspb.Message.getFieldWithDefault(msg, 30, 0),
    failedTasks: jspb.Message.getFieldWithDefault(msg, 31, 0),
    runningTasks: jspb.Message.getFieldWithDefault(msg, 32, 0),
    stuckTasks: jspb.Message.getFieldWithDefault(msg, 33, 0),
    expectedItems: jspb.Message.getFieldWithDefault(msg, 34, 0),
    completedItems: jspb.Message.getFieldWithDefault(msg, 35, 0),
    failedItems: jspb.Message.getFieldWithDefault(msg, 36, 0),
    averageTaskSeconds: jspb.Message.getFloatingPointFieldWithDefault(msg, 37, 0.0),
    taskTypesList: jspb.Message.toObjectList(msg.getTaskTypesList(),
    proto.saasphoto.AnalyticsBreakdown.toObject, includeInstance),
    taskTrendList: jspb.Message.toObjectList(msg.getTaskTrendList(),
    proto.saasphoto.AnalyticsTrendPoint.toObject, includeInstance),
    storageNearLimit: jspb.Message.getFieldWithDefault(msg, 40, 0),
    storageOverLimit: jspb.Message.getFieldWithDefault(msg, 41, 0),
    bandwidthOverused: jspb.Message.getFieldWithDefault(msg, 42, 0),
    riskAccountsList: jspb.Message.toObjectList(msg.getRiskAccountsList(),
    proto.saasphoto.AnalyticsRiskAccount.toObject, includeInstance),
    sharedContent: jspb.Message.getFieldWithDefault(msg, 44, 0),
    viewedContent: jspb.Message.getFieldWithDefault(msg, 45, 0),
    zeroViewContent: jspb.Message.getFieldWithDefault(msg, 46, 0),
    totalViews: jspb.Message.getFieldWithDefault(msg, 47, 0),
    sharingAccountsList: jspb.Message.toObjectList(msg.getSharingAccountsList(),
    proto.saasphoto.AnalyticsBreakdown.toObject, includeInstance),
    activeSharingAccounts: jspb.Message.getFieldWithDefault(msg, 49, 0),
    sharingDataAvailableFrom: jspb.Message.getFieldWithDefault(msg, 50, 0),
    sharingFilesList: jspb.Message.toObjectList(msg.getSharingFilesList(),
    proto.saasphoto.AnalyticsBreakdown.toObject, includeInstance),
    sharingFileExtensionsList: (f = jspb.Message.getRepeatedField(msg, 53)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse}
 */
proto.saasphoto.GetBusinessInsightsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.GetBusinessInsightsResponse;
  return proto.saasphoto.GetBusinessInsightsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.GetBusinessInsightsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse}
 */
proto.saasphoto.GetBusinessInsightsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setGrossRevenue(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setRefunds(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setNetRevenue(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSuccessfulPayments(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPayingUsers(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageRevenuePerUser(value);
      break;
    case 7:
      var value = new proto.saasphoto.AnalyticsBreakdown;
      reader.readMessage(value,proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader);
      msg.addRevenueCategories(value);
      break;
    case 8:
      var value = new proto.saasphoto.AnalyticsBreakdown;
      reader.readMessage(value,proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader);
      msg.addRevenueCountries(value);
      break;
    case 9:
      var value = new proto.saasphoto.AnalyticsBreakdown;
      reader.readMessage(value,proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader);
      msg.addRevenuePlans(value);
      break;
    case 10:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRegistrations(value);
      break;
    case 11:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialsStarted(value);
      break;
    case 12:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setPaidStarted(value);
      break;
    case 13:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCancellations(value);
      break;
    case 14:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTrialConversions(value);
      break;
    case 15:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setEligibleTrials(value);
      break;
    case 16:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiring7Days(value);
      break;
    case 17:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpiring30Days(value);
      break;
    case 18:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActiveHostingPlans(value);
      break;
    case 19:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActiveAiPlans(value);
      break;
    case 20:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setDailyActiveUsers(value);
      break;
    case 21:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setWeeklyActiveUsers(value);
      break;
    case 22:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setMonthlyActiveUsers(value);
      break;
    case 23:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActiveUsers(value);
      break;
    case 24:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRetention7Users(value);
      break;
    case 25:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRetention7Eligible(value);
      break;
    case 26:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRetention30Users(value);
      break;
    case 27:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRetention30Eligible(value);
      break;
    case 28:
      var value = new proto.saasphoto.AnalyticsTrendPoint;
      reader.readMessage(value,proto.saasphoto.AnalyticsTrendPoint.deserializeBinaryFromReader);
      msg.addActiveUserTrend(value);
      break;
    case 29:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setProcessingTasks(value);
      break;
    case 30:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletedTasks(value);
      break;
    case 31:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFailedTasks(value);
      break;
    case 32:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setRunningTasks(value);
      break;
    case 33:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStuckTasks(value);
      break;
    case 34:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setExpectedItems(value);
      break;
    case 35:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCompletedItems(value);
      break;
    case 36:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setFailedItems(value);
      break;
    case 37:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setAverageTaskSeconds(value);
      break;
    case 38:
      var value = new proto.saasphoto.AnalyticsBreakdown;
      reader.readMessage(value,proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader);
      msg.addTaskTypes(value);
      break;
    case 39:
      var value = new proto.saasphoto.AnalyticsTrendPoint;
      reader.readMessage(value,proto.saasphoto.AnalyticsTrendPoint.deserializeBinaryFromReader);
      msg.addTaskTrend(value);
      break;
    case 40:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStorageNearLimit(value);
      break;
    case 41:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setStorageOverLimit(value);
      break;
    case 42:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setBandwidthOverused(value);
      break;
    case 43:
      var value = new proto.saasphoto.AnalyticsRiskAccount;
      reader.readMessage(value,proto.saasphoto.AnalyticsRiskAccount.deserializeBinaryFromReader);
      msg.addRiskAccounts(value);
      break;
    case 44:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSharedContent(value);
      break;
    case 45:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setViewedContent(value);
      break;
    case 46:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setZeroViewContent(value);
      break;
    case 47:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setTotalViews(value);
      break;
    case 48:
      var value = new proto.saasphoto.AnalyticsBreakdown;
      reader.readMessage(value,proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader);
      msg.addSharingAccounts(value);
      break;
    case 49:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setActiveSharingAccounts(value);
      break;
    case 50:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setSharingDataAvailableFrom(value);
      break;
    case 52:
      var value = new proto.saasphoto.AnalyticsBreakdown;
      reader.readMessage(value,proto.saasphoto.AnalyticsBreakdown.deserializeBinaryFromReader);
      msg.addSharingFiles(value);
      break;
    case 53:
      var value = /** @type {string} */ (reader.readString());
      msg.addSharingFileExtensions(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.GetBusinessInsightsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.GetBusinessInsightsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.GetBusinessInsightsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getGrossRevenue();
  if (f !== 0.0) {
    writer.writeDouble(
      1,
      f
    );
  }
  f = message.getRefunds();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
  f = message.getNetRevenue();
  if (f !== 0.0) {
    writer.writeDouble(
      3,
      f
    );
  }
  f = message.getSuccessfulPayments();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getPayingUsers();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getAverageRevenuePerUser();
  if (f !== 0.0) {
    writer.writeDouble(
      6,
      f
    );
  }
  f = message.getRevenueCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      7,
      f,
      proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter
    );
  }
  f = message.getRevenueCountriesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter
    );
  }
  f = message.getRevenuePlansList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter
    );
  }
  f = message.getRegistrations();
  if (f !== 0) {
    writer.writeInt64(
      10,
      f
    );
  }
  f = message.getTrialsStarted();
  if (f !== 0) {
    writer.writeInt64(
      11,
      f
    );
  }
  f = message.getPaidStarted();
  if (f !== 0) {
    writer.writeInt64(
      12,
      f
    );
  }
  f = message.getCancellations();
  if (f !== 0) {
    writer.writeInt64(
      13,
      f
    );
  }
  f = message.getTrialConversions();
  if (f !== 0) {
    writer.writeInt64(
      14,
      f
    );
  }
  f = message.getEligibleTrials();
  if (f !== 0) {
    writer.writeInt64(
      15,
      f
    );
  }
  f = message.getExpiring7Days();
  if (f !== 0) {
    writer.writeInt64(
      16,
      f
    );
  }
  f = message.getExpiring30Days();
  if (f !== 0) {
    writer.writeInt64(
      17,
      f
    );
  }
  f = message.getActiveHostingPlans();
  if (f !== 0) {
    writer.writeInt64(
      18,
      f
    );
  }
  f = message.getActiveAiPlans();
  if (f !== 0) {
    writer.writeInt64(
      19,
      f
    );
  }
  f = message.getDailyActiveUsers();
  if (f !== 0) {
    writer.writeInt64(
      20,
      f
    );
  }
  f = message.getWeeklyActiveUsers();
  if (f !== 0) {
    writer.writeInt64(
      21,
      f
    );
  }
  f = message.getMonthlyActiveUsers();
  if (f !== 0) {
    writer.writeInt64(
      22,
      f
    );
  }
  f = message.getActiveUsers();
  if (f !== 0) {
    writer.writeInt64(
      23,
      f
    );
  }
  f = message.getRetention7Users();
  if (f !== 0) {
    writer.writeInt64(
      24,
      f
    );
  }
  f = message.getRetention7Eligible();
  if (f !== 0) {
    writer.writeInt64(
      25,
      f
    );
  }
  f = message.getRetention30Users();
  if (f !== 0) {
    writer.writeInt64(
      26,
      f
    );
  }
  f = message.getRetention30Eligible();
  if (f !== 0) {
    writer.writeInt64(
      27,
      f
    );
  }
  f = message.getActiveUserTrendList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      28,
      f,
      proto.saasphoto.AnalyticsTrendPoint.serializeBinaryToWriter
    );
  }
  f = message.getProcessingTasks();
  if (f !== 0) {
    writer.writeInt64(
      29,
      f
    );
  }
  f = message.getCompletedTasks();
  if (f !== 0) {
    writer.writeInt64(
      30,
      f
    );
  }
  f = message.getFailedTasks();
  if (f !== 0) {
    writer.writeInt64(
      31,
      f
    );
  }
  f = message.getRunningTasks();
  if (f !== 0) {
    writer.writeInt64(
      32,
      f
    );
  }
  f = message.getStuckTasks();
  if (f !== 0) {
    writer.writeInt64(
      33,
      f
    );
  }
  f = message.getExpectedItems();
  if (f !== 0) {
    writer.writeInt64(
      34,
      f
    );
  }
  f = message.getCompletedItems();
  if (f !== 0) {
    writer.writeInt64(
      35,
      f
    );
  }
  f = message.getFailedItems();
  if (f !== 0) {
    writer.writeInt64(
      36,
      f
    );
  }
  f = message.getAverageTaskSeconds();
  if (f !== 0.0) {
    writer.writeDouble(
      37,
      f
    );
  }
  f = message.getTaskTypesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      38,
      f,
      proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter
    );
  }
  f = message.getTaskTrendList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      39,
      f,
      proto.saasphoto.AnalyticsTrendPoint.serializeBinaryToWriter
    );
  }
  f = message.getStorageNearLimit();
  if (f !== 0) {
    writer.writeInt64(
      40,
      f
    );
  }
  f = message.getStorageOverLimit();
  if (f !== 0) {
    writer.writeInt64(
      41,
      f
    );
  }
  f = message.getBandwidthOverused();
  if (f !== 0) {
    writer.writeInt64(
      42,
      f
    );
  }
  f = message.getRiskAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      43,
      f,
      proto.saasphoto.AnalyticsRiskAccount.serializeBinaryToWriter
    );
  }
  f = message.getSharedContent();
  if (f !== 0) {
    writer.writeInt64(
      44,
      f
    );
  }
  f = message.getViewedContent();
  if (f !== 0) {
    writer.writeInt64(
      45,
      f
    );
  }
  f = message.getZeroViewContent();
  if (f !== 0) {
    writer.writeInt64(
      46,
      f
    );
  }
  f = message.getTotalViews();
  if (f !== 0) {
    writer.writeInt64(
      47,
      f
    );
  }
  f = message.getSharingAccountsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      48,
      f,
      proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter
    );
  }
  f = message.getActiveSharingAccounts();
  if (f !== 0) {
    writer.writeInt64(
      49,
      f
    );
  }
  f = message.getSharingDataAvailableFrom();
  if (f !== 0) {
    writer.writeInt64(
      50,
      f
    );
  }
  f = message.getSharingFilesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      52,
      f,
      proto.saasphoto.AnalyticsBreakdown.serializeBinaryToWriter
    );
  }
  f = message.getSharingFileExtensionsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      53,
      f
    );
  }
};


/**
 * optional double gross_revenue = 1;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getGrossRevenue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setGrossRevenue = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional double refunds = 2;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRefunds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRefunds = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional double net_revenue = 3;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getNetRevenue = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setNetRevenue = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional int64 successful_payments = 4;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getSuccessfulPayments = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setSuccessfulPayments = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 paying_users = 5;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getPayingUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setPayingUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional double average_revenue_per_user = 6;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getAverageRevenuePerUser = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setAverageRevenuePerUser = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


/**
 * repeated AnalyticsBreakdown revenue_categories = 7;
 * @return {!Array<!proto.saasphoto.AnalyticsBreakdown>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRevenueCategoriesList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsBreakdown>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsBreakdown, 7));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsBreakdown>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRevenueCategoriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 7, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsBreakdown=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addRevenueCategories = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 7, opt_value, proto.saasphoto.AnalyticsBreakdown, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearRevenueCategoriesList = function() {
  return this.setRevenueCategoriesList([]);
};


/**
 * repeated AnalyticsBreakdown revenue_countries = 8;
 * @return {!Array<!proto.saasphoto.AnalyticsBreakdown>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRevenueCountriesList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsBreakdown>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsBreakdown, 8));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsBreakdown>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRevenueCountriesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsBreakdown=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addRevenueCountries = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.saasphoto.AnalyticsBreakdown, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearRevenueCountriesList = function() {
  return this.setRevenueCountriesList([]);
};


/**
 * repeated AnalyticsBreakdown revenue_plans = 9;
 * @return {!Array<!proto.saasphoto.AnalyticsBreakdown>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRevenuePlansList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsBreakdown>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsBreakdown, 9));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsBreakdown>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRevenuePlansList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsBreakdown=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addRevenuePlans = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.saasphoto.AnalyticsBreakdown, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearRevenuePlansList = function() {
  return this.setRevenuePlansList([]);
};


/**
 * optional int64 registrations = 10;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRegistrations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 10, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRegistrations = function(value) {
  return jspb.Message.setProto3IntField(this, 10, value);
};


/**
 * optional int64 trials_started = 11;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getTrialsStarted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 11, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setTrialsStarted = function(value) {
  return jspb.Message.setProto3IntField(this, 11, value);
};


/**
 * optional int64 paid_started = 12;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getPaidStarted = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 12, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setPaidStarted = function(value) {
  return jspb.Message.setProto3IntField(this, 12, value);
};


/**
 * optional int64 cancellations = 13;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getCancellations = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 13, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setCancellations = function(value) {
  return jspb.Message.setProto3IntField(this, 13, value);
};


/**
 * optional int64 trial_conversions = 14;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getTrialConversions = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 14, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setTrialConversions = function(value) {
  return jspb.Message.setProto3IntField(this, 14, value);
};


/**
 * optional int64 eligible_trials = 15;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getEligibleTrials = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 15, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setEligibleTrials = function(value) {
  return jspb.Message.setProto3IntField(this, 15, value);
};


/**
 * optional int64 expiring_7_days = 16;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getExpiring7Days = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 16, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setExpiring7Days = function(value) {
  return jspb.Message.setProto3IntField(this, 16, value);
};


/**
 * optional int64 expiring_30_days = 17;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getExpiring30Days = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 17, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setExpiring30Days = function(value) {
  return jspb.Message.setProto3IntField(this, 17, value);
};


/**
 * optional int64 active_hosting_plans = 18;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getActiveHostingPlans = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 18, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setActiveHostingPlans = function(value) {
  return jspb.Message.setProto3IntField(this, 18, value);
};


/**
 * optional int64 active_ai_plans = 19;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getActiveAiPlans = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 19, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setActiveAiPlans = function(value) {
  return jspb.Message.setProto3IntField(this, 19, value);
};


/**
 * optional int64 daily_active_users = 20;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getDailyActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 20, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setDailyActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 20, value);
};


/**
 * optional int64 weekly_active_users = 21;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getWeeklyActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 21, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setWeeklyActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 21, value);
};


/**
 * optional int64 monthly_active_users = 22;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getMonthlyActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 22, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setMonthlyActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 22, value);
};


/**
 * optional int64 active_users = 23;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getActiveUsers = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 23, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setActiveUsers = function(value) {
  return jspb.Message.setProto3IntField(this, 23, value);
};


/**
 * optional int64 retention_7_users = 24;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRetention7Users = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 24, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRetention7Users = function(value) {
  return jspb.Message.setProto3IntField(this, 24, value);
};


/**
 * optional int64 retention_7_eligible = 25;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRetention7Eligible = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 25, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRetention7Eligible = function(value) {
  return jspb.Message.setProto3IntField(this, 25, value);
};


/**
 * optional int64 retention_30_users = 26;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRetention30Users = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 26, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRetention30Users = function(value) {
  return jspb.Message.setProto3IntField(this, 26, value);
};


/**
 * optional int64 retention_30_eligible = 27;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRetention30Eligible = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 27, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRetention30Eligible = function(value) {
  return jspb.Message.setProto3IntField(this, 27, value);
};


/**
 * repeated AnalyticsTrendPoint active_user_trend = 28;
 * @return {!Array<!proto.saasphoto.AnalyticsTrendPoint>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getActiveUserTrendList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsTrendPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsTrendPoint, 28));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsTrendPoint>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setActiveUserTrendList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 28, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsTrendPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsTrendPoint}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addActiveUserTrend = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 28, opt_value, proto.saasphoto.AnalyticsTrendPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearActiveUserTrendList = function() {
  return this.setActiveUserTrendList([]);
};


/**
 * optional int64 processing_tasks = 29;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getProcessingTasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 29, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setProcessingTasks = function(value) {
  return jspb.Message.setProto3IntField(this, 29, value);
};


/**
 * optional int64 completed_tasks = 30;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getCompletedTasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 30, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setCompletedTasks = function(value) {
  return jspb.Message.setProto3IntField(this, 30, value);
};


/**
 * optional int64 failed_tasks = 31;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getFailedTasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 31, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setFailedTasks = function(value) {
  return jspb.Message.setProto3IntField(this, 31, value);
};


/**
 * optional int64 running_tasks = 32;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRunningTasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 32, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRunningTasks = function(value) {
  return jspb.Message.setProto3IntField(this, 32, value);
};


/**
 * optional int64 stuck_tasks = 33;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getStuckTasks = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 33, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setStuckTasks = function(value) {
  return jspb.Message.setProto3IntField(this, 33, value);
};


/**
 * optional int64 expected_items = 34;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getExpectedItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 34, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setExpectedItems = function(value) {
  return jspb.Message.setProto3IntField(this, 34, value);
};


/**
 * optional int64 completed_items = 35;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getCompletedItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 35, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setCompletedItems = function(value) {
  return jspb.Message.setProto3IntField(this, 35, value);
};


/**
 * optional int64 failed_items = 36;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getFailedItems = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 36, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setFailedItems = function(value) {
  return jspb.Message.setProto3IntField(this, 36, value);
};


/**
 * optional double average_task_seconds = 37;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getAverageTaskSeconds = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 37, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setAverageTaskSeconds = function(value) {
  return jspb.Message.setProto3FloatField(this, 37, value);
};


/**
 * repeated AnalyticsBreakdown task_types = 38;
 * @return {!Array<!proto.saasphoto.AnalyticsBreakdown>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getTaskTypesList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsBreakdown>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsBreakdown, 38));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsBreakdown>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setTaskTypesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 38, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsBreakdown=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addTaskTypes = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 38, opt_value, proto.saasphoto.AnalyticsBreakdown, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearTaskTypesList = function() {
  return this.setTaskTypesList([]);
};


/**
 * repeated AnalyticsTrendPoint task_trend = 39;
 * @return {!Array<!proto.saasphoto.AnalyticsTrendPoint>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getTaskTrendList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsTrendPoint>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsTrendPoint, 39));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsTrendPoint>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setTaskTrendList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 39, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsTrendPoint=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsTrendPoint}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addTaskTrend = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 39, opt_value, proto.saasphoto.AnalyticsTrendPoint, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearTaskTrendList = function() {
  return this.setTaskTrendList([]);
};


/**
 * optional int64 storage_near_limit = 40;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getStorageNearLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 40, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setStorageNearLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 40, value);
};


/**
 * optional int64 storage_over_limit = 41;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getStorageOverLimit = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 41, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setStorageOverLimit = function(value) {
  return jspb.Message.setProto3IntField(this, 41, value);
};


/**
 * optional int64 bandwidth_overused = 42;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getBandwidthOverused = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 42, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setBandwidthOverused = function(value) {
  return jspb.Message.setProto3IntField(this, 42, value);
};


/**
 * repeated AnalyticsRiskAccount risk_accounts = 43;
 * @return {!Array<!proto.saasphoto.AnalyticsRiskAccount>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getRiskAccountsList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsRiskAccount>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsRiskAccount, 43));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsRiskAccount>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setRiskAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 43, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsRiskAccount=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsRiskAccount}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addRiskAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 43, opt_value, proto.saasphoto.AnalyticsRiskAccount, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearRiskAccountsList = function() {
  return this.setRiskAccountsList([]);
};


/**
 * optional int64 shared_content = 44;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getSharedContent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 44, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setSharedContent = function(value) {
  return jspb.Message.setProto3IntField(this, 44, value);
};


/**
 * optional int64 viewed_content = 45;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getViewedContent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 45, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setViewedContent = function(value) {
  return jspb.Message.setProto3IntField(this, 45, value);
};


/**
 * optional int64 zero_view_content = 46;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getZeroViewContent = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 46, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setZeroViewContent = function(value) {
  return jspb.Message.setProto3IntField(this, 46, value);
};


/**
 * optional int64 total_views = 47;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getTotalViews = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 47, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setTotalViews = function(value) {
  return jspb.Message.setProto3IntField(this, 47, value);
};


/**
 * repeated AnalyticsBreakdown sharing_accounts = 48;
 * @return {!Array<!proto.saasphoto.AnalyticsBreakdown>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getSharingAccountsList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsBreakdown>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsBreakdown, 48));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsBreakdown>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setSharingAccountsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 48, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsBreakdown=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addSharingAccounts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 48, opt_value, proto.saasphoto.AnalyticsBreakdown, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearSharingAccountsList = function() {
  return this.setSharingAccountsList([]);
};


/**
 * optional int64 active_sharing_accounts = 49;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getActiveSharingAccounts = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 49, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setActiveSharingAccounts = function(value) {
  return jspb.Message.setProto3IntField(this, 49, value);
};


/**
 * optional int64 sharing_data_available_from = 50;
 * @return {number}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getSharingDataAvailableFrom = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 50, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setSharingDataAvailableFrom = function(value) {
  return jspb.Message.setProto3IntField(this, 50, value);
};


/**
 * repeated AnalyticsBreakdown sharing_files = 52;
 * @return {!Array<!proto.saasphoto.AnalyticsBreakdown>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getSharingFilesList = function() {
  return /** @type{!Array<!proto.saasphoto.AnalyticsBreakdown>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.saasphoto.AnalyticsBreakdown, 52));
};


/**
 * @param {!Array<!proto.saasphoto.AnalyticsBreakdown>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
*/
proto.saasphoto.GetBusinessInsightsResponse.prototype.setSharingFilesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 52, value);
};


/**
 * @param {!proto.saasphoto.AnalyticsBreakdown=} opt_value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.AnalyticsBreakdown}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addSharingFiles = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 52, opt_value, proto.saasphoto.AnalyticsBreakdown, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearSharingFilesList = function() {
  return this.setSharingFilesList([]);
};


/**
 * repeated string sharing_file_extensions = 53;
 * @return {!Array<string>}
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.getSharingFileExtensionsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 53));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.setSharingFileExtensionsList = function(value) {
  return jspb.Message.setField(this, 53, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.addSharingFileExtensions = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 53, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.saasphoto.GetBusinessInsightsResponse} returns this
 */
proto.saasphoto.GetBusinessInsightsResponse.prototype.clearSharingFileExtensionsList = function() {
  return this.setSharingFileExtensionsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.AddUseCreditModuleRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.AddUseCreditModuleRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.AddUseCreditModuleRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AddUseCreditModuleRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    userId: jspb.Message.getFieldWithDefault(msg, 1, 0),
    credit: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.AddUseCreditModuleRequest}
 */
proto.saasphoto.AddUseCreditModuleRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.AddUseCreditModuleRequest;
  return proto.saasphoto.AddUseCreditModuleRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.AddUseCreditModuleRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.AddUseCreditModuleRequest}
 */
proto.saasphoto.AddUseCreditModuleRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readUint32());
      msg.setUserId(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readDouble());
      msg.setCredit(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.AddUseCreditModuleRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.AddUseCreditModuleRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.AddUseCreditModuleRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.AddUseCreditModuleRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getUserId();
  if (f !== 0) {
    writer.writeUint32(
      1,
      f
    );
  }
  f = message.getCredit();
  if (f !== 0.0) {
    writer.writeDouble(
      2,
      f
    );
  }
};


/**
 * optional uint32 user_id = 1;
 * @return {number}
 */
proto.saasphoto.AddUseCreditModuleRequest.prototype.getUserId = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AddUseCreditModuleRequest} returns this
 */
proto.saasphoto.AddUseCreditModuleRequest.prototype.setUserId = function(value) {
  return jspb.Message.setProto3IntField(this, 1, value);
};


/**
 * optional double credit = 2;
 * @return {number}
 */
proto.saasphoto.AddUseCreditModuleRequest.prototype.getCredit = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.saasphoto.AddUseCreditModuleRequest} returns this
 */
proto.saasphoto.AddUseCreditModuleRequest.prototype.setCredit = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.IsUserEmailExistRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.IsUserEmailExistRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.IsUserEmailExistRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.IsUserEmailExistRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    email: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.IsUserEmailExistRequest}
 */
proto.saasphoto.IsUserEmailExistRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.IsUserEmailExistRequest;
  return proto.saasphoto.IsUserEmailExistRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.IsUserEmailExistRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.IsUserEmailExistRequest}
 */
proto.saasphoto.IsUserEmailExistRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setEmail(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.IsUserEmailExistRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.IsUserEmailExistRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.IsUserEmailExistRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.IsUserEmailExistRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getEmail();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string email = 1;
 * @return {string}
 */
proto.saasphoto.IsUserEmailExistRequest.prototype.getEmail = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.saasphoto.IsUserEmailExistRequest} returns this
 */
proto.saasphoto.IsUserEmailExistRequest.prototype.setEmail = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.saasphoto.IsUserEmailExistResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.saasphoto.IsUserEmailExistResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.saasphoto.IsUserEmailExistResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.IsUserEmailExistResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    exists: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.saasphoto.IsUserEmailExistResponse}
 */
proto.saasphoto.IsUserEmailExistResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.saasphoto.IsUserEmailExistResponse;
  return proto.saasphoto.IsUserEmailExistResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.saasphoto.IsUserEmailExistResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.saasphoto.IsUserEmailExistResponse}
 */
proto.saasphoto.IsUserEmailExistResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setExists(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.saasphoto.IsUserEmailExistResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.saasphoto.IsUserEmailExistResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.saasphoto.IsUserEmailExistResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.saasphoto.IsUserEmailExistResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getExists();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool exists = 1;
 * @return {boolean}
 */
proto.saasphoto.IsUserEmailExistResponse.prototype.getExists = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.saasphoto.IsUserEmailExistResponse} returns this
 */
proto.saasphoto.IsUserEmailExistResponse.prototype.setExists = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};


/**
 * @enum {number}
 */
proto.saasphoto.CreateAccountErrorCode = {
  CREATE_ACCOUNT_OK: 0,
  CREATE_ACCOUNT_EMAIL_HAS_EXISTED: 1,
  CREATE_ACCOUNT_FAILED_TO_SEND_EMAIL_WITH_TEMPORARY_PASSWORD: 2
};

/**
 * @enum {number}
 */
proto.saasphoto.TransactionName = {
  TRANSACTION_NAME_IS_PLAN: 0,
  TRANSACTION_NAME_IS_REFILL_BANDWIDTH: 1
};

/**
 * @enum {number}
 */
proto.saasphoto.UserStatus = {
  USER_STATUS_IS_BAN: 0,
  USER_STATUS_IS_ALLOW: 1
};

goog.object.extend(exports, proto.saasphoto);
